import {
  Activity,
  Eye,
  Home,
  Partner,
  Profile,
  Teacher,
  Replay,
} from "./google-material-icons";
import { IconPropTypes } from ".";

const copy = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.59995 13.3996L2.19995 13.3996C1.53721 13.3996 0.999951 12.8624 0.999951 12.1996L0.999953 3.39961C0.999954 2.29504 1.89538 1.39961 2.99995 1.39961L11.8 1.39961C12.4627 1.39961 13 1.93687 13 2.59961L13 4.99961M10.5999 20.5996L17.8 20.5996C19.1254 20.5996 20.2 19.5251 20.2 18.1996L20.2 10.9996C20.2 9.67413 19.1254 8.59961 17.8 8.59961L10.6 8.59961C9.27447 8.59961 8.19995 9.67413 8.19995 10.9996L8.19995 18.1996C8.19995 19.5251 9.27447 20.5996 10.5999 20.5996Z"
      stroke="#169FED"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const zoom = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9_2649)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z"
        fill="#3984FD"
      />
      <path
        d="M5 9C5 8.44772 5.44772 8 6 8H12C13.6569 8 15 9.34315 15 11V15C15 15.5523 14.5523 16 14 16H8C6.34315 16 5 14.6569 5 13V9Z"
        fill="white"
      />
      <path
        d="M15.5 11.751C15.5 11.2666 15.6758 10.7986 15.9948 10.434L17.6856 8.50177C18.1416 7.98059 19 8.30312 19 8.99564V15.0035C19 15.696 18.1416 16.0185 17.6856 15.4973L15.9948 13.5651C15.6758 13.2005 15.5 12.7325 15.5 12.2481V11.751Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_2649">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const spin = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? 16}
    height={height ?? 16}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2,12A10.94,10.94,0,0,1,5,4.65c-.21-.19-.42-.36-.62-.55h0A11,11,0,0,0,12,23c.34,0,.67,0,1-.05C6,23,2,17.74,2,12Z"
    >
      <animateTransform
        attributeName="transform"
        dur="0.6s"
        repeatCount="indefinite"
        type="rotate"
        values="0 12 12;360 12 12"
      ></animateTransform>
    </path>
  </svg>
);

const left_arrow = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 7H4.33L9.92 1.41L8.5 0L0.5 8L8.5 16L9.91 14.59L4.33 9H16.5V7Z"
      fill="black"
    />
  </svg>
);

const close = ({ width, height }: IconPropTypes) => (
  <svg
    width={width ?? "28"}
    height={height ?? "28"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1666 5.83399L5.83331 22.1673M22.1666 22.1673L5.83331 5.83398"
      stroke="currentColor"
      strokeWidth="2.33333"
      strokeLinecap="round"
    />
  </svg>
);

const audio = () => (
  <svg
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.583 0.51016C15.9458 0.650511 16.1997 0.949939 16.2649 1.29786L16.2814 1.47535V24.5229C16.2814 24.9449 16.0052 25.3258 15.5807 25.4891C15.2169 25.629 14.8051 25.5855 14.4881 25.3841L14.3381 25.2703L7.65096 19.2465H3.7134C1.93174 19.2465 0.467551 18 0.301458 16.4064L0.285767 16.1037V9.84106C0.285767 8.20743 1.64516 6.86489 3.3833 6.7126L3.7134 6.69821H7.65379L14.3416 0.724943C14.6707 0.431023 15.1597 0.346417 15.583 0.51016ZM22.5374 2.64697L22.7351 2.77017L22.9586 2.94736C23.1023 3.0658 23.3007 3.23738 23.5356 3.46101C24.0047 3.90769 24.6231 4.56589 25.24 5.42753C26.4749 7.15214 27.7143 9.70824 27.7143 13.0076C27.7143 16.3072 26.4747 18.8595 25.2391 20.5803C24.6219 21.44 24.0034 22.0962 23.534 22.5415L23.2112 22.8368L22.7845 23.1908L22.7091 23.2476C22.2144 23.6069 21.4941 23.5317 21.1022 23.0783C20.7547 22.676 20.781 22.112 21.1367 21.7389L21.4319 21.4928C21.5384 21.4054 21.6972 21.269 21.891 21.0853C22.2793 20.7169 22.8041 20.1615 23.3306 19.4284C24.382 17.9636 25.4292 15.8058 25.4292 13.0076C25.4292 10.2093 24.382 8.04691 23.3297 6.57744C22.891 5.96462 22.4532 5.47517 22.0945 5.11492L21.7079 4.74559L21.2866 4.39062C20.7937 4.03011 20.7112 3.37051 21.104 2.91809C21.4534 2.51575 22.06 2.41196 22.5374 2.64697ZM20.254 6.83723L20.4816 6.98335L20.787 7.2468L20.9105 7.36546C21.1698 7.62198 21.5044 7.99774 21.8357 8.49739C22.5018 9.50212 23.1464 10.9969 23.1464 12.9961C23.1464 14.9952 22.5018 16.4916 21.8362 17.4978C21.5053 17.9982 21.1708 18.3749 20.9116 18.632L20.6795 18.8504L20.5189 18.9867L20.4281 19.0573L20.283 19.1177C19.9805 19.2288 19.2731 19.4099 18.8224 18.8928C18.4739 18.4932 18.4964 17.9314 18.8473 17.5569L19.1545 17.2862L19.2332 17.2102C19.4035 17.0413 19.6413 16.7758 19.8824 16.4112C20.3614 15.6874 20.8613 14.5624 20.8613 12.9961C20.8613 11.4299 20.3614 10.3072 19.8831 9.5858C19.7023 9.31322 19.5234 9.0963 19.3736 8.93403L19.156 8.71429L18.9995 8.5781C18.5088 8.21935 18.4281 7.56142 18.8208 7.1089C19.1699 6.70642 19.7766 6.60241 20.254 6.83723Z"
      fill="#E1E8ED"
    />
  </svg>
);

const language = () => (
  <svg
    width="47"
    height="43"
    viewBox="0 0 47 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3166 1.77041L9.55503 1.83603C5.54523 1.86994 3.57697 3.87162 3.61086 7.88113L3.67664 15.662C3.71121 19.7509 5.71303 21.719 9.72199 21.5858L17.5034 21.52C21.5934 21.5847 23.5617 19.583 23.4277 15.4751L23.3621 7.71414C23.4274 3.70379 21.4256 1.73567 17.3166 1.77041ZM17.6056 17.1719C16.2557 17.1833 14.9412 16.6783 13.8418 15.7745C12.6186 16.6781 11.1343 17.2266 9.52644 17.2402C8.71257 17.2471 8.03195 16.578 8.02507 15.7641C8.01819 14.9503 8.6874 14.2698 9.50127 14.2629C11.526 14.2458 13.2016 12.8421 13.8008 10.9314L9.47341 10.9679C8.65954 10.9748 7.97892 10.3057 7.97204 9.49185C7.96516 8.67804 8.63437 7.99746 9.44824 7.99058L12.009 7.96893C12.082 7.214 12.6923 6.61332 13.4665 6.60678C14.2406 6.60023 14.861 7.1905 14.9468 7.94409L15.4629 7.93973L15.5026 7.93939L15.5423 7.93906L17.5075 7.92244C18.3214 7.91556 19.002 8.58472 19.0089 9.39853C19.0158 10.2123 18.3664 10.8927 17.5327 10.8998L16.8776 10.9053C16.707 11.8596 16.3374 12.756 15.848 13.574C16.3874 13.9665 16.965 14.1998 17.5804 14.1946C18.3943 14.1877 19.0749 14.8569 19.0818 15.6707C19.0887 16.4845 18.4194 17.1651 17.6056 17.1719Z"
      fill="#292D32"
    />
    <path
      d="M31.0062 0.699098C39.4679 1.28932 45.8831 8.66604 45.2929 17.1271C45.2363 17.9396 44.5155 18.5663 43.703 18.5096C42.8905 18.4529 42.2638 17.7322 42.3204 16.9198C42.7295 11.0545 38.9901 5.85558 33.5907 4.1847L34.0636 5.11371C34.43 5.85609 34.1484 6.75238 33.406 7.11874C32.6834 7.48648 31.7672 7.20355 31.4008 6.46117L29.5619 2.84837C29.3163 2.37327 29.3564 1.79863 29.6458 1.36085C29.955 0.924447 30.4712 0.661777 31.0062 0.699098Z"
      fill="#292D32"
    />
    <path
      d="M3.45081 24.6435C4.26329 24.7002 4.89007 25.4209 4.8334 26.2334C4.42429 32.0987 8.16374 37.2976 13.5631 38.9684L13.0903 38.0394C12.7239 37.2971 13.0054 36.4008 13.7478 36.0344C14.4705 35.6667 15.3866 35.9496 15.753 36.692L17.5919 40.3048C17.8375 40.7799 17.7975 41.3545 17.508 41.7923C17.1988 42.2287 16.6827 42.4914 16.1476 42.4541C7.68594 41.8638 1.27074 34.4871 1.86091 26.026C1.91757 25.2136 2.63833 24.5869 3.45081 24.6435Z"
      fill="#292D32"
    />
    <path
      d="M33.342 21.2077C27.7839 21.2547 23.296 25.7987 23.3432 31.3763C23.3902 36.934 27.9345 41.4215 33.5125 41.3743C39.0706 41.3274 43.5584 36.7834 43.5113 31.2058C43.4641 25.6282 38.92 21.1605 33.342 21.2077ZM38.3906 36.033C37.6591 36.3965 36.7635 36.1262 36.38 35.3751L36.0368 34.7031L30.8955 34.7466L30.5638 35.4243C30.3101 35.9425 29.7767 36.2448 29.2407 36.2493C29.0223 36.2512 28.7836 36.1937 28.5843 36.0961C27.8466 35.7252 27.5413 34.8345 27.8924 34.097L32.0688 25.5856C32.3226 25.0872 32.8361 24.7652 33.3919 24.7605C33.9477 24.7558 34.4665 25.069 34.7289 25.5829L39.0485 34.0226C39.4121 34.754 39.1219 35.6497 38.3906 36.033Z"
      fill="#292D32"
    />
    <path
      d="M32.3576 31.7514L34.5213 31.7331L33.4112 29.5788L32.3576 31.7514Z"
      fill="#292D32"
    />
  </svg>
);

const correct = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.5 14.4992C26.5 21.2912 21.1274 26.7972 14.5 26.7972C7.87258 26.7972 2.5 21.2912 2.5 14.4992C2.5 7.70717 7.87258 2.20117 14.5 2.20117C16.3827 2.20117 18.1642 2.64552 19.75 3.43748M24.25 6.81292L13.75 17.5737L10.75 14.4992"
      stroke="currentColor"
      strokeWidth="4.16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const wrong = () => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 13.4995C26 20.2906 20.6274 25.7958 14 25.7958C7.37258 25.7958 2 20.2906 2 13.4995C2 6.70839 7.37258 1.20312 14 1.20312C20.6274 1.20312 26 6.70839 26 13.4995Z"
      fill="white"
    />
    <path
      d="M14 13.4995V7.35131M14 18.0566V18.1106M26 13.4995C26 20.2906 20.6274 25.7958 14 25.7958C7.37258 25.7958 2 20.2906 2 13.4995C2 6.70839 7.37258 1.20312 14 1.20312C20.6274 1.20312 26 6.70839 26 13.4995Z"
      stroke="#FF5252"
      strokeWidth="2.07972"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const logo = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="72" height="72" rx="36" fill="#169FED" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7776 40.9281L37.4635 39.729L42.9342 41.7342L44.1037 44.9452L45.8514 48.8201L45.741 49.7753L18.7776 49.9515V40.9281Z"
      fill="white"
    />
    <path
      d="M50.2239 26.5057C50.5003 26.0472 50.8548 25.6455 51.27 25.3201C52.1861 24.6021 52.9657 24.6427 53.6869 25.5369C55.753 28.1112 57.3773 30.9564 57.5852 34.3435C57.6826 36.5388 57.2981 38.7283 56.4612 40.7453C56.3394 41.2873 56.0993 41.7927 55.7595 42.2221C55.3509 42.8734 54.859 43.4637 54.2977 43.9766C53.8818 44.2612 53.4855 44.4373 53.4725 43.6244C53.4331 43.4002 53.4049 43.1741 53.3881 42.9469C53.6349 40.9146 52.4135 39.7833 51.1335 38.6791C50.081 37.7781 48.9115 38.1033 47.8849 38.5775C46.9493 38.9907 46.0852 38.7469 45.1886 38.6588C44.8637 38.6249 44.8702 38.381 44.8702 38.1304C44.867 38.083 44.867 38.0355 44.8702 37.9881C44.8705 37.4309 44.988 36.8805 45.2146 36.3758C46.7284 33.2529 48.0084 29.9944 49.899 27.0747C50.094 26.9595 50.1395 26.7224 50.2499 26.5395L50.2239 26.5057Z"
      fill="white"
    />
    <path
      d="M46.7738 27.6308C46.7846 27.9853 46.724 28.3383 46.596 28.667C46.4679 28.9956 46.2753 29.2927 46.0305 29.539C45.7856 29.7854 45.4941 29.9755 45.1745 30.0972C44.8549 30.2189 44.5144 30.2695 44.1749 30.2456C43.5212 30.1927 42.9108 29.8839 42.4661 29.3814C42.0215 28.8789 41.7755 28.2196 41.7775 27.5359C41.7775 26.0456 42.934 25.0159 44.4998 25.0362C45.8902 25.0633 46.7738 26.0659 46.7738 27.6308Z"
      fill="white"
    />
    <path
      d="M46.3582 42.5943C46.0723 42.5943 45.78 42.5943 45.4941 42.5943C44.6105 42.513 44.1362 41.7814 44.2466 40.562C44.3181 39.783 44.8964 39.6746 45.5136 39.6813C46.6381 39.6757 47.753 39.4648 48.8077 39.0581C50.1071 38.6042 51.0427 39.2071 51.9133 40.0675C52.3357 40.4875 51.9133 40.7449 51.6599 40.9075C50.063 41.9354 48.2342 42.5056 46.3582 42.5604V42.5943Z"
      fill="white"
    />
    <path
      d="M51.6336 22.6576C51.1194 20.795 49.9952 19.1793 48.4565 18.0917C46.6644 16.7814 44.6621 15.8156 42.5441 15.2397C40.6607 14.683 38.7126 14.4003 36.7551 14.3997C36.1053 14.3997 35.4556 14.3997 34.8514 14.4945C35.0463 14.9619 35.5011 15.0026 35.709 15.2939C35.709 15.3684 35.8584 15.4768 35.7935 15.5106C35.697 15.5704 35.5873 15.6031 35.4751 15.6055C35.3646 15.6052 35.2565 15.5723 35.1632 15.5106C34.8839 15.4361 34.6045 15.3752 34.3316 15.2735C33.3944 14.8802 32.3822 14.7202 31.3754 14.8061C26.706 15.4565 22.0367 16.1136 17.3674 16.7774C15.7301 17.0078 15.6911 17.062 16.2889 18.7555C16.38 18.976 16.4909 19.1869 16.6202 19.3856C18.0401 21.6954 19.9466 23.6369 22.1948 25.0624C23.4943 25.9025 24.3454 26.878 24.2479 28.5512C24.249 28.882 24.2861 29.2115 24.3584 29.5335C24.7807 32.1077 25.2745 34.6752 25.6188 37.2562C25.9892 40.0879 25.9307 40.1014 23.4683 41.436C21.2005 42.6242 18.9928 43.9334 16.8541 45.3583C16.296 45.7486 15.7662 46.181 15.2688 46.6522C15.2932 46.7075 15.3149 46.764 15.3338 46.8216V46.8893C18.5824 47.3838 21.792 48.2442 25.0016 49.0029C27.2252 49.0684 29.4221 49.5265 31.4988 50.3578L32.3694 50.4865C35.9276 50.9317 39.531 50.7831 43.0443 50.0462C43.218 49.9636 43.3985 49.8978 43.5836 49.8497C43.5581 49.802 43.5363 49.7521 43.5186 49.7007C42.8689 48.5829 42.3361 47.3906 41.6669 46.3135C41.3225 45.845 40.8294 45.5195 40.2758 45.3954C39.7223 45.2713 39.1445 45.3566 38.6457 45.6361C38.1517 45.8756 37.6702 46.1424 37.2034 46.4354C36.9027 46.6428 36.5542 46.7622 36.1943 46.7813C35.8343 46.8004 35.476 46.7184 35.1567 46.5438C34.6912 46.3053 34.3126 45.9154 34.0782 45.4328C34.0364 45.3646 33.9909 45.299 33.9418 45.2364C33.3159 44.3383 32.8049 43.3591 32.4214 42.3234C32.1505 41.5219 31.6222 40.8426 30.926 40.4006C30.2297 39.9586 29.4084 39.7812 28.6011 39.8982C28.8261 39.7315 29.0913 39.6336 29.3668 39.6156C29.6424 39.5977 29.9172 39.6604 30.1604 39.7966C31.2404 40.3281 32.081 41.2749 32.5059 42.4386C33.0191 43.5816 33.7256 44.6188 34.5915 45.5006C35.0391 45.7345 35.5267 45.8741 36.0261 45.9113C36.5256 45.9485 37.0272 45.8826 37.5022 45.7174C38.1519 45.548 38.7497 45.2703 39.3864 45.0941C40.6014 44.7622 41.0627 44.9519 41.7579 46.0629C42.0281 46.5542 42.2627 47.066 42.4596 47.5939C42.6941 48.2696 43.0565 48.8892 43.5251 49.4161C43.6596 49.5568 43.8102 49.6797 43.9734 49.782H44.0774L44.4997 49.7413C44.935 49.6465 45.3703 49.5449 45.7992 49.4297L45.8381 49.3416C45.8765 49.2574 45.9269 49.1797 45.9876 49.1113C45.9999 48.8351 45.927 48.5621 45.7797 48.3323C44.935 46.5371 43.759 44.8773 43.6486 42.7773C43.6462 42.3853 43.5114 42.0067 43.2677 41.7081C43.0241 41.4095 42.6874 41.21 42.3167 41.1447C41.1061 40.7665 39.9752 40.1528 38.9836 39.3359C38.7588 39.2265 38.5726 39.0465 38.4508 38.8211C34.494 34.2484 35.8 28.1244 39.289 24.8795C39.4106 24.8382 39.5219 24.7694 39.6151 24.6781C39.7083 24.5867 39.7811 24.4751 39.8282 24.3511C41.0315 23.0908 42.5632 22.2264 44.2332 21.8651C45.9033 21.5038 47.6383 21.6616 49.2232 22.3188C49.8729 22.5898 50.4901 22.8879 51.1334 23.1589C51.2958 23.2266 51.4907 23.4298 51.6791 23.2131C51.8675 22.9963 51.6791 22.8676 51.6336 22.705V22.6576Z"
      fill="white"
    />
    <path
      d="M23.9231 37.8321C23.5811 34.9408 23.3815 32.033 23.3253 29.1203C23.2742 28.5684 23.1874 28.0207 23.0654 27.481C21.9544 29.5133 20.9279 31.2949 19.8168 33.0291C19.6674 33.2595 19.3815 33.5237 19.8623 33.8217C20.8434 34.4382 20.9798 35.0208 20.512 35.9556C20.4334 36.1591 20.3123 36.3417 20.1575 36.4903C20.0027 36.6388 19.8182 36.7496 19.6172 36.8145C19.4162 36.8793 19.2039 36.8967 18.9957 36.8653C18.7875 36.834 18.5886 36.7546 18.4134 36.6331C18.0041 36.4366 17.8157 36.484 17.5948 36.8905C16.9451 38.1099 16.2174 39.3157 15.5222 40.5283C15.1648 41.1515 14.7685 41.7816 14.4372 42.4996V42.7029C14.4761 42.4387 14.4956 42.9671 14.4372 42.818C14.434 42.845 14.434 42.8723 14.4372 42.8993C15.9566 42.668 17.432 42.1903 18.8098 41.4835C20.1677 40.6909 21.6556 40.176 23.046 39.4512C23.3566 39.3396 23.6173 39.1133 23.7789 38.815C23.9405 38.5168 23.9918 38.1671 23.9231 37.8321Z"
      fill="white"
    />
    <path
      d="M38.99 39.3361C38.9207 39.3474 38.8497 39.3424 38.7825 39.3212C38.7152 39.3001 38.6534 39.2635 38.6016 39.214C38.5498 39.1646 38.5093 39.1037 38.4832 39.0357C38.4571 38.9678 38.446 38.8946 38.4508 38.8215C38.6781 38.9269 38.8655 39.1078 38.9835 39.3361H38.99Z"
      fill="white"
    />
    <path
      d="M50.2238 26.5059C50.2238 26.7834 50.2238 27.0407 49.8729 27.0407C49.8838 26.9281 49.9217 26.8202 49.983 26.7267C50.0443 26.6333 50.127 26.5573 50.2238 26.5059Z"
      fill="white"
    />
    <path
      d="M31.1545 27.6296C31.7002 28.788 32.0836 29.9464 31.5703 31.2539C31.2601 31.912 30.787 32.4718 30.1999 32.8755C29.6128 33.2792 28.933 33.5122 28.2307 33.5504C27.9344 33.5402 27.6437 33.4632 27.3786 33.3247C27.1135 33.1862 26.8804 32.9895 26.6951 32.7481C26.5099 32.5067 26.377 32.2264 26.3057 31.9263C26.2343 31.6263 26.226 31.3137 26.2816 31.01C26.3374 30.7723 26.4402 30.5494 26.5833 30.3554C26.7264 30.1614 26.9067 30.0007 27.1127 29.8834C27.3187 29.7661 27.5459 29.6949 27.7798 29.6743C28.0137 29.6536 28.2491 29.684 28.4711 29.7635C29.0689 29.9939 28.731 30.441 28.5816 30.7865C28.4321 31.132 28.0228 31.3284 28.4646 31.701C28.9064 32.0736 29.1728 31.7687 29.4782 31.5452C29.8475 31.3369 30.1271 30.9902 30.2607 30.5752C30.3942 30.1602 30.3716 29.7078 30.1975 29.3094C30.0234 28.9111 29.7107 28.5965 29.3227 28.4293C28.9347 28.2621 28.5003 28.2547 28.1073 28.4087L27.6005 28.5306C27.2431 28.6051 26.8208 28.8422 26.5999 28.3748C26.4961 28.1544 26.4718 27.9024 26.5314 27.6648C26.5911 27.4273 26.7307 27.22 26.9248 27.0809C27.3265 26.7881 27.7836 26.5883 28.2654 26.4948C28.7473 26.4013 29.2428 26.4164 29.7186 26.539C29.9163 26.5842 30.1115 26.6407 30.3033 26.7083C30.7002 26.8836 31.0152 27.2145 31.1804 27.6296H31.1545Z"
      fill="white"
    />
    <path
      d="M44.7141 50.9602C44.8635 50.7436 45.013 50.4998 45.1754 50.2832C44.8513 50.3594 44.5144 50.353 44.1932 50.2646C43.872 50.1762 43.5759 50.0084 43.3302 49.7754C43.3757 50.3103 43.8045 50.5743 44.1489 50.818C44.2882 50.9187 44.4536 50.973 44.6231 50.9738L44.7141 50.9602Z"
      fill="white"
    />
    <path
      d="M33.9222 45.4941C34.3576 45.7717 34.8384 46.0019 34.9813 46.5842C34.743 46.487 34.5262 46.3402 34.3441 46.1528C34.162 45.9654 34.0185 45.7413 33.9222 45.4941Z"
      fill="white"
    />
    <path
      d="M31.1545 27.6286L30.2773 26.7214C30.3967 26.6988 30.5196 26.7066 30.6354 26.7441C30.7513 26.7816 30.8568 26.8476 30.9429 26.9367C31.029 27.0258 31.0932 27.1352 31.13 27.2556C31.1669 27.3761 31.1752 27.504 31.1545 27.6286Z"
      fill="white"
    />
    <path
      d="M27.8215 26.5594L30.9272 33.4354C31.0182 33.6318 31.382 33.5438 31.3495 33.3134L31.291 32.8257C31.291 32.5276 30.8038 32.5276 30.8427 32.8257L30.9012 33.3134L31.317 33.1983L28.2374 26.3291C28.1139 26.0514 27.7306 26.2885 27.8475 26.5662L27.8215 26.5594Z"
      fill="white"
    />
    <path
      d="M28.2763 26.6684C28.9324 28.4679 29.7209 30.2118 30.6347 31.8847L31.0181 31.6476C29.6342 29.5678 28.2178 27.4339 27.5616 24.9545L27.1717 25.1103C28.5231 27.2104 29.9634 29.2427 31.4924 31.2072C31.9255 31.7672 32.3587 32.3227 32.7918 32.8737C32.9672 33.0837 33.2661 32.8127 33.1492 32.5892C32.0984 30.4536 30.8769 28.4141 29.4977 26.4923C29.3613 26.3094 29.0494 26.4923 29.1209 26.7158C29.6994 28.2452 30.4015 29.7205 31.2195 31.1259C31.2394 31.1592 31.2672 31.1867 31.3002 31.2057C31.3332 31.2246 31.3702 31.2345 31.4079 31.2343C31.4671 31.2343 31.524 31.2103 31.5664 31.1673C31.6089 31.1243 31.6336 31.0657 31.6353 31.004C31.6344 30.9633 31.6232 30.9235 31.6028 30.8888C31.605 30.8731 31.605 30.8571 31.6028 30.8414C31.6041 30.888 31.6185 30.9332 31.6443 30.9712C31.67 31.0093 31.706 31.0387 31.7476 31.0556C31.7893 31.0725 31.8348 31.0762 31.8784 31.0663C31.9221 31.0564 31.962 31.0333 31.9932 30.9999C32.0243 30.9665 32.0454 30.9243 32.0536 30.8785C32.0619 30.8327 32.057 30.7853 32.0396 30.7424C32.0222 30.6995 31.9931 30.6628 31.9559 30.6371C31.9186 30.6113 31.8749 30.5976 31.8302 30.5975C31.7995 30.5965 31.769 30.6022 31.7405 30.6142C31.7121 30.6262 31.6863 30.6442 31.665 30.6672C31.6436 30.6901 31.627 30.7175 31.6163 30.7475C31.6056 30.7775 31.601 30.8095 31.6028 30.8414L31.5573 30.6721C31.5184 30.5162 31.4859 30.3604 31.4599 30.1978C31.3884 29.7778 31.3364 29.3443 31.291 28.9107C31.2 28.0945 31.1544 27.2734 31.1545 26.4516V26.0587C31.1449 25.9619 31.1449 25.8643 31.1545 25.7674C31.1515 25.7246 31.1515 25.6816 31.1545 25.6387V25.571L31.1935 25.4084C31.1935 25.3474 31.1935 25.3474 31.1935 25.4084L30.8167 25.3068C31.2065 27.8878 30.9986 30.5298 30.8946 33.1311C30.8946 33.856 30.8491 34.5808 30.8427 35.2989L31.226 35.1363L30.9401 34.845C30.7322 34.635 30.4073 34.967 30.6217 35.177L30.9076 35.4683C30.9513 35.5068 31.0064 35.5284 31.0636 35.5292C31.1228 35.5293 31.1796 35.5052 31.2221 35.4622C31.2646 35.4192 31.2893 35.3606 31.291 35.2989C31.291 32.6502 31.5703 29.9946 31.4534 27.3459C31.4227 26.6198 31.3533 25.8961 31.2455 25.1781C31.2336 25.1286 31.2059 25.0848 31.1669 25.054C31.1279 25.0232 31.08 25.0072 31.0311 25.0087C30.9727 25.0096 30.9168 25.0338 30.8751 25.0765C30.7298 25.2966 30.6611 25.5619 30.6802 25.8284C30.6802 26.0452 30.6802 26.262 30.6802 26.5058C30.6802 26.7497 30.6802 26.9394 30.6802 27.1833C30.714 28.2002 30.8094 29.2138 30.9661 30.2182C30.9961 30.5532 31.0795 30.8806 31.213 31.1869L31.6028 30.9498C30.8005 29.5794 30.1115 28.1403 29.5432 26.6481L29.1664 26.8784C30.5235 28.7762 31.7233 30.7909 32.7528 32.9008L33.1037 32.6231C31.5487 30.7217 30.076 28.7481 28.6856 26.7023L27.5356 24.9477C27.5156 24.9144 27.4879 24.887 27.4549 24.868C27.4219 24.849 27.3848 24.8392 27.3472 24.8394C27.2868 24.8394 27.229 24.8643 27.1864 24.9088C27.1437 24.9533 27.1198 25.0136 27.1198 25.0765C27.1198 25.0765 27.1198 25.0765 27.1198 25.1307C27.7695 27.6439 29.2183 29.8117 30.6282 31.905C30.6474 31.941 30.6757 31.9709 30.7101 31.9912C30.7445 32.0115 30.7836 32.0216 30.8232 32.0201C30.8817 32.0201 30.9379 31.9959 30.9794 31.9527C31.0208 31.9095 31.0441 31.8509 31.0441 31.7898C31.0532 31.7497 31.0532 31.708 31.0441 31.6679C30.1508 30.0425 29.3776 28.3485 28.7311 26.6007C28.6271 26.3162 28.1918 26.4381 28.2957 26.7226L28.2763 26.6684Z"
      fill="white"
    />
    <path
      d="M30.8295 31.2408L31.1934 31.9178L31.3753 32.2631V32.3308V32.3714V32.4053C31.3694 32.4411 31.3694 32.4778 31.3753 32.5136C31.3753 32.5545 31.3855 32.5947 31.4049 32.6303C31.4242 32.6659 31.4521 32.6957 31.4858 32.7167C31.5198 32.7259 31.5556 32.7259 31.5897 32.7167C31.6284 32.7174 31.6665 32.7078 31.7006 32.6889C31.7347 32.6699 31.7636 32.6422 31.7846 32.6084C31.9536 32.3105 31.7197 31.9923 31.5832 31.735L31.1739 30.9564C31.1524 30.9226 31.1236 30.8945 31.0897 30.8745C31.0558 30.8545 31.0179 30.8431 30.979 30.8413C30.938 30.8431 30.898 30.8546 30.862 30.8752C30.8291 30.8965 30.8022 30.9266 30.7839 30.9622C30.7657 30.9979 30.7568 31.0379 30.7581 31.0783C30.7493 31.1138 30.7493 31.1511 30.7581 31.1866L30.8295 31.2408Z"
      fill="white"
    />
    <path
      d="M44.9935 48.4481L40.9197 49.0442L41.0367 49.4981C41.8283 49.2768 42.6592 49.2559 43.4602 49.4371L43.4017 49.0103L42.9014 49.2813C42.661 49.4033 42.8299 49.7623 43.0703 49.7081L44.0059 49.4845C44.0528 49.4711 44.0942 49.4419 44.1235 49.4015C44.1529 49.3611 44.1686 49.3117 44.1683 49.261C44.1679 49.198 44.1447 49.1376 44.1034 49.0916L42.4856 47.3574L41.6604 46.4767C41.4337 46.2077 41.1883 45.9563 40.9262 45.7248C40.659 45.5204 40.341 45.4005 40.0101 45.3793C39.6463 45.3387 39.2824 45.3116 38.9186 45.2845C38.3521 45.1964 37.7763 45.1964 37.2098 45.2845C36.9426 45.3091 36.6892 45.4193 36.4845 45.6C36.2798 45.7807 36.1337 46.0231 36.0663 46.2938C36.0626 46.3117 36.0626 46.3302 36.0663 46.348C36.0663 46.4109 36.0903 46.4712 36.1329 46.5157C36.1756 46.5602 36.2334 46.5851 36.2937 46.5851H36.3522C36.9003 46.4957 37.4542 46.4504 38.009 46.4496C38.2689 46.4496 38.5418 46.4496 38.8016 46.4835V46.0161C38.1028 46.0997 37.4 46.1426 36.6966 46.1448C35.5805 46.142 34.4671 46.0331 33.37 45.8196V46.2735C33.8313 46.1038 34.3167 46.0168 34.8059 46.0161C35.246 46.0141 35.6839 46.0803 36.1053 46.2125L36.2223 45.7654C34.9821 45.4696 33.8525 44.8006 32.9737 43.8415C32.0186 42.7983 31.5898 41.3689 30.6412 40.3257C30.1646 39.7745 29.5193 39.413 28.8154 39.3027C28.5621 39.3027 28.5166 39.6956 28.757 39.7702C30.9385 40.3499 32.8504 41.7214 34.1497 43.6383L34.455 43.3131C33.1762 42.7248 31.9961 41.9266 30.9595 40.9489L30.6866 41.3147C32.0293 42.4022 33.4958 43.3124 35.0528 44.0244C35.8626 44.3448 36.7035 44.572 37.5607 44.7019C38.0016 44.7669 38.4363 44.8711 38.8601 45.0135C39.2274 45.1512 39.5837 45.3188 39.9257 45.5148C40.6801 46.0191 41.5135 46.3814 42.3881 46.5851H42.4596C42.5098 46.5833 42.5579 46.5643 42.5966 46.5309C42.6353 46.4975 42.6623 46.4518 42.6735 46.4007C42.6846 46.3497 42.6792 46.2962 42.6582 46.2487C42.6371 46.2012 42.6015 46.1623 42.557 46.138C41.3883 45.3295 40.143 44.6485 38.8406 44.1057C38.5743 43.9906 38.4573 44.4444 38.7237 44.5596C39.9874 45.0885 41.1958 45.7514 42.3296 46.5377L42.5051 46.1109C41.7363 45.9396 41.002 45.6302 40.335 45.1964C39.6172 44.7696 38.8385 44.4654 38.0285 44.2954C37.1749 44.1768 36.3318 43.9865 35.5076 43.7264C34.7201 43.4298 33.9645 43.0484 33.253 42.5883C32.4344 42.0802 31.6547 41.4976 30.8816 40.9286C30.6736 40.766 30.4203 41.1183 30.6087 41.2944C31.6776 42.3002 32.8924 43.1233 34.2081 43.7331C34.3836 43.8144 34.6564 43.6248 34.507 43.4147C33.1444 41.4011 31.138 39.96 28.8479 39.3502L28.7895 39.8108C30.1604 39.9937 30.8816 41.4773 31.4988 42.5815C32.1162 43.7555 33.0193 44.7391 34.1172 45.4335C34.7235 45.8015 35.3811 46.0689 36.0663 46.2261H36.1183C36.1775 46.2261 36.2344 46.2021 36.2769 46.1591C36.3193 46.116 36.344 46.0575 36.3457 45.9958C36.346 45.9451 36.3303 45.8957 36.3009 45.8552C36.2715 45.8148 36.2302 45.7856 36.1833 45.7722C35.7335 45.6238 35.2646 45.5484 34.7929 45.5487C34.2618 45.5489 33.7346 45.6428 33.2335 45.8264C33.0451 45.8942 32.9996 46.2329 33.2335 46.2803C34.3689 46.5028 35.5218 46.6139 36.6771 46.6122C37.3825 46.6121 38.0875 46.5714 38.7887 46.4903C38.849 46.4903 38.9068 46.4653 38.9495 46.4208C38.9921 46.3764 39.0161 46.3161 39.0161 46.2532C39.0144 46.1915 38.9897 46.1329 38.9472 46.0899C38.9047 46.0469 38.8479 46.0228 38.7887 46.0229C38.5288 46.0229 38.2624 46.0229 38.0025 46.0229C37.4041 46.0251 36.8068 46.0749 36.2158 46.1719L36.4886 46.4632C36.5731 46.0229 36.9564 45.8535 37.3398 45.7858C37.8484 45.7112 38.3645 45.7112 38.8731 45.7858L39.8737 45.8738C40.1708 45.8752 40.459 45.9801 40.6923 46.1719C40.9457 46.3954 41.1601 46.6596 41.3875 46.9035L42.1152 47.6352L43.785 49.4236L43.8825 49.0374L42.9469 49.261L43.1223 49.6878L43.6356 49.4168C43.6672 49.3941 43.6932 49.3637 43.7113 49.3284C43.7293 49.293 43.739 49.2536 43.7395 49.2136C43.7402 49.162 43.7247 49.1116 43.6953 49.07C43.666 49.0284 43.6245 48.998 43.5771 48.9832C43.18 48.8939 42.7749 48.8485 42.3686 48.8478C41.8791 48.8473 41.3917 48.9156 40.9197 49.051C40.6274 49.1323 40.7573 49.5387 41.0367 49.4981L45.1169 48.902C45.3963 48.8613 45.2794 48.4142 44.9935 48.4548V48.4481Z"
      fill="white"
    />
    <path
      d="M43.8047 45.3045C43.155 44.7016 42.5053 44.0919 41.9205 43.4619C41.836 43.3738 41.7581 43.279 41.6801 43.1841H39.8934C31.486 43.1367 23.0851 43.2383 14.6777 43.2519C15.2235 51.2659 22.195 57.5999 30.7193 57.5999C37.2165 57.5999 42.7522 53.9486 45.3056 48.6849C44.6799 47.621 44.1761 46.4841 43.8047 45.2977V45.3045Z"
      fill="white"
      stroke="white"
      strokeWidth="0.54"
      strokeMiterlimit="10"
    />
    <path
      d="M23.9233 32.8466L24.7485 38.266L25.1773 38.1441C24.766 36.5531 24.5242 34.9196 24.4561 33.2734L24.0338 33.3885L25.5217 36.6267L26.2493 38.2051C26.5104 38.696 26.6967 39.2262 26.8016 39.7767L27.2434 39.7158C26.8085 38.5622 26.444 37.3811 26.1519 36.1796C25.866 34.9941 25.6776 33.8018 25.5022 32.6027C25.4886 32.3425 25.4239 32.088 25.3121 31.855C25.2004 31.6219 25.0439 31.4153 24.8524 31.2479C24.8183 31.2387 24.7826 31.2387 24.7485 31.2479C24.7098 31.2472 24.6717 31.2567 24.6376 31.2757C24.6035 31.2947 24.5745 31.3224 24.5536 31.3562C24.3236 32.0057 24.2219 32.697 24.2547 33.3885V33.6392C24.2547 34.276 24.2872 34.9195 24.3457 35.5563C24.4897 37.0011 24.7838 38.4253 25.2228 39.8038C25.236 39.8606 25.2689 39.9102 25.3151 39.9433C25.3613 39.9763 25.4176 39.9904 25.4731 39.9829C25.5287 39.9753 25.5796 39.9466 25.6162 39.9023C25.6527 39.8581 25.6722 39.8013 25.6711 39.7429C25.5931 38.2706 25.5563 36.8005 25.5606 35.3328L25.1123 35.3937L25.892 37.8664C25.983 38.1509 26.4183 38.0222 26.3273 37.7444L25.5152 35.2718C25.5089 35.2149 25.4831 35.1622 25.4424 35.1236C25.4018 35.085 25.3492 35.0631 25.2943 35.0618C25.2339 35.0618 25.1761 35.0868 25.1335 35.1312C25.0908 35.1757 25.0668 35.236 25.0668 35.2989V35.3328C25.0668 36.8005 25.1058 38.2683 25.1838 39.7361L25.6256 39.6751C25.0006 37.7225 24.6824 35.6774 24.6835 33.6189V33.5376C24.6356 32.8614 24.7174 32.1821 24.9239 31.5391L24.625 31.6272C25.0733 31.9659 25.0733 32.7179 25.1513 33.226C25.2488 33.9847 25.3787 34.7299 25.5411 35.475C25.8634 36.9605 26.2979 38.417 26.8406 39.8309C26.925 40.0545 27.3149 40.0545 27.2889 39.77C27.1985 39.2094 27.023 38.6674 26.7691 38.1644L26.0089 36.5183L24.4561 33.1785C24.4343 33.1455 24.4052 33.1185 24.3713 33.0996C24.3374 33.0808 24.2996 33.0706 24.2612 33.0701C24.202 33.0701 24.1451 33.0942 24.1027 33.1372C24.0602 33.1802 24.0355 33.2388 24.0338 33.3005C24.1118 34.9881 24.3645 36.6621 24.7875 38.2931C24.8589 38.5912 25.2618 38.4625 25.2163 38.1712L24.3976 32.7179C24.3522 32.4266 23.9168 32.5485 23.9623 32.8466H23.9233Z"
      fill="white"
    />
    <path
      d="M24.2674 33.2388L24.014 37.3712L23.8906 39.4034C23.8982 40.0314 23.781 40.6542 23.5462 41.2325L23.9556 41.4154C24.062 41.0173 24.2729 40.6581 24.5644 40.378C24.8559 40.098 25.2166 39.9083 25.6058 39.8302L25.4304 39.4034C24.4411 40.0885 23.3927 40.6759 22.2988 41.158L22.5262 41.5645C23.7388 40.7928 24.9951 40.0983 26.2881 39.4847L26.0152 39.1189C24.6649 40.3735 23.2152 41.5066 21.6815 42.5061L21.9544 42.8787C23.2539 41.219 24.6443 39.6338 26.0996 38.1367C26.2686 37.9537 26.0347 37.6083 25.8268 37.7708L20.4081 41.9303L20.6745 42.2961C22.3594 40.8148 24.092 39.4102 25.8722 38.0825L25.5994 37.7099C24.2079 38.8634 22.7498 39.9267 21.2332 40.8938L21.4606 41.3003L25.4369 38.5025C25.4689 38.4817 25.4952 38.4527 25.5134 38.4183C25.5316 38.3839 25.541 38.3453 25.5409 38.306C25.5409 38.2431 25.5169 38.1828 25.4743 38.1384C25.4316 38.0939 25.3738 38.0689 25.3135 38.0689C25.2795 38.0591 25.2435 38.0591 25.2095 38.0689C23.3167 38.9722 21.4628 39.9431 19.6479 40.9819C19.388 41.1377 19.6479 41.4967 19.8753 41.3883C20.5989 41.0782 21.3527 40.851 22.1234 40.7109L21.9999 40.2638C21.488 40.3735 20.9826 40.5138 20.4861 40.6838C20.2522 40.7583 20.0183 40.8464 19.7844 40.9412C19.7297 40.9515 19.6779 40.9746 19.6329 41.0086C19.5879 41.0426 19.5509 41.0867 19.5245 41.1377C19.4912 41.2072 19.4734 41.2836 19.4725 41.3612C19.469 41.3837 19.469 41.4065 19.4725 41.429C19.5245 41.8964 20.0118 42.1471 20.3431 42.3774L21.688 43.3122L21.805 42.8787H21.3307C20.5545 42.8804 19.7806 42.7895 19.0242 42.6077V43.0616C20.2093 42.7686 21.4087 42.5424 22.6171 42.3842C22.6711 42.3831 22.7229 42.3621 22.7634 42.3249C22.8039 42.2876 22.8303 42.2366 22.838 42.1809V42.1471C22.8383 42.0963 22.8226 42.0469 22.7932 42.0065C22.7639 41.9661 22.7225 41.9369 22.6756 41.9235C21.3401 41.6832 19.9893 41.5473 18.6344 41.517L18.7253 42.0454C20.0106 41.7205 21.312 41.4695 22.6236 41.2935C22.903 41.2596 22.9225 40.8261 22.6236 40.8261H22.5782C21.1004 40.8196 19.6303 41.048 18.2185 41.5035C18.1716 41.5169 18.1303 41.5461 18.1009 41.5865C18.0715 41.6269 18.0558 41.6763 18.0561 41.727C18.0555 41.7786 18.071 41.829 18.1003 41.8706C18.1296 41.9122 18.1711 41.9426 18.2185 41.9574L18.6668 42.1132L18.6084 41.6864C18.0202 41.9605 17.3997 42.1518 16.7632 42.2554C16.5423 42.2893 16.5552 42.6619 16.7632 42.7093L17.9911 42.9803L18.0561 42.5264H14.9699C14.9373 42.5206 14.9038 42.5223 14.8719 42.5314C14.84 42.5404 14.8103 42.5566 14.785 42.5789C14.7597 42.6012 14.7394 42.6289 14.7254 42.6602C14.7115 42.6915 14.7042 42.7256 14.7042 42.7601C14.7042 42.7946 14.7115 42.8287 14.7254 42.86C14.7394 42.8914 14.7597 42.9191 14.785 42.9414C14.8103 42.9636 14.84 42.9798 14.8719 42.9889C14.9038 42.998 14.9373 42.9997 14.9699 42.9938C16.6722 42.9938 18.381 42.9058 20.0832 42.7635C20.3691 42.7635 20.3691 42.269 20.0832 42.2961C18.3875 42.4383 16.6787 42.5129 14.9699 42.5264V42.9938H18.0561C18.1121 42.9951 18.1666 42.9747 18.2091 42.9366C18.2515 42.8985 18.279 42.8454 18.2863 42.7875C18.2935 42.7295 18.28 42.6709 18.2483 42.6227C18.2166 42.5745 18.169 42.5402 18.1146 42.5264L16.8801 42.2487V42.7229C17.5538 42.6076 18.2094 42.398 18.8293 42.0996C19.0177 42.0116 18.9462 41.727 18.7773 41.6728L18.329 41.517V41.9709C19.6896 41.5262 21.1068 41.2978 22.5327 41.2935H22.6236V40.8261C21.2635 40.9999 19.9142 41.2555 18.5824 41.5916C18.5295 41.601 18.4815 41.6296 18.4469 41.6724C18.4123 41.7152 18.3933 41.7693 18.3933 41.8253C18.3933 41.8812 18.4123 41.9354 18.4469 41.9782C18.4815 42.0209 18.5295 42.0496 18.5824 42.059C19.8893 42.09 21.1923 42.2214 22.4807 42.4519L22.5392 41.9845C21.2916 42.1395 20.0531 42.3656 18.8293 42.6619C18.7825 42.6766 18.7416 42.7067 18.7125 42.7475C18.6834 42.7884 18.6677 42.8379 18.6677 42.8888C18.6677 42.9397 18.6834 42.9893 18.7125 43.0301C18.7416 43.071 18.7825 43.101 18.8293 43.1158C19.6477 43.3098 20.4849 43.4053 21.3242 43.4003H21.7985C21.8476 43.3988 21.895 43.3808 21.9335 43.3489C21.972 43.317 21.9995 43.2729 22.012 43.2233C22.0244 43.1737 22.0211 43.1212 22.0025 43.0737C21.9839 43.0263 21.9511 42.9863 21.9089 42.96L20.7459 42.1606C20.564 42.0387 20.3756 41.91 20.2002 41.7812C20.0247 41.6525 19.8493 41.5238 19.9273 41.3816L19.7909 41.4899C20.5457 41.2009 21.3213 40.9744 22.1104 40.8125C22.3962 40.7448 22.2728 40.3044 21.9934 40.3586C21.1853 40.5117 20.3963 40.7594 19.6414 41.097L19.8688 41.5035C21.6794 40.4602 23.5354 39.487 25.4369 38.5838L25.2095 38.1841L21.2397 40.9819C20.9993 41.1512 21.2397 41.5441 21.4671 41.3883C23.016 40.3993 24.5046 39.3111 25.9242 38.1299C26.1256 37.9673 25.8592 37.6083 25.6513 37.7641C23.8191 39.1189 22.0497 40.5461 20.3431 42.0454C20.1482 42.2148 20.4081 42.5738 20.616 42.4113L26.0347 38.2586L25.7618 37.886C24.3064 39.4102 22.929 41.0022 21.6101 42.628C21.4606 42.8245 21.6556 43.1497 21.883 43.0006C23.4483 41.973 24.9283 40.8105 26.3075 39.5254C26.5155 39.3357 26.2556 39.058 26.0347 39.1528C24.7471 39.7709 23.4934 40.4629 22.2793 41.2257C22.0259 41.3816 22.2793 41.7474 22.5067 41.6322C23.5978 41.1486 24.644 40.5612 25.6318 39.8777C25.6643 39.8553 25.6912 39.8252 25.7104 39.7899C25.7296 39.7545 25.7406 39.715 25.7423 39.6744C25.7423 39.6115 25.7183 39.5512 25.6757 39.5068C25.633 39.4623 25.5752 39.4373 25.5149 39.4373H25.4629C25.0017 39.5422 24.5765 39.776 24.2331 40.1138C23.8897 40.4515 23.641 40.8805 23.5138 41.3545C23.5033 41.4079 23.5109 41.4634 23.5352 41.5117C23.5595 41.56 23.599 41.5981 23.647 41.6196C23.6951 41.6411 23.7488 41.6446 23.7991 41.6296C23.8493 41.6147 23.8931 41.5821 23.9231 41.5374C24.1755 40.9561 24.3083 40.3261 24.3129 39.688C24.3584 39.0105 24.3974 38.2857 24.4429 37.5744L24.7027 33.2795C24.7027 32.9814 24.2739 32.9814 24.2544 33.2795L24.2674 33.2388Z"
      fill="white"
    />
    <path
      d="M22.078 35.8139L22.156 36.0713C22.1651 36.1276 22.1928 36.1787 22.2344 36.2158C22.2759 36.253 22.3287 36.2737 22.3834 36.2745C22.4437 36.2745 22.5015 36.2495 22.5442 36.2051C22.5868 36.1606 22.6108 36.1003 22.6108 36.0374V36.0036C22.7054 35.4216 22.9085 34.8647 23.2085 34.3642C23.4994 33.8396 23.7388 33.2858 23.9232 32.7112C24.0995 32.0746 24.2276 31.4245 24.3065 30.767L24.5729 28.7008L24.9303 26.3163V26.2756C24.9312 26.2442 24.9259 26.213 24.9148 26.1838C24.9037 26.1546 24.887 26.1281 24.8657 26.1059C24.8444 26.0837 24.8189 26.0662 24.791 26.0547C24.763 26.0431 24.733 26.0376 24.7029 26.0385C24.658 26.0392 24.6143 26.0537 24.5773 26.0802C24.5403 26.1067 24.5116 26.1441 24.495 26.1876C23.7998 28.0505 23.9622 30.1505 23.1436 31.9728L23.5659 32.0948C23.5659 29.8525 25.3591 27.5695 24.1636 25.3204C24.1437 25.2871 24.1159 25.2597 24.0829 25.2407C24.0499 25.2217 24.0129 25.2119 23.9752 25.2121C23.9453 25.2121 23.9158 25.2182 23.8882 25.2301C23.8606 25.242 23.8355 25.2595 23.8144 25.2815C23.7933 25.3035 23.7765 25.3297 23.7651 25.3584C23.7537 25.3872 23.7478 25.418 23.7478 25.4492C23.7441 25.467 23.7441 25.4855 23.7478 25.5034C24.0005 26.708 23.9692 27.9586 23.6568 29.1479C23.3119 30.2797 23.1216 31.4564 23.0916 32.6435C23.0916 32.8603 23.4099 32.989 23.5074 32.7654C23.9672 31.7673 24.4769 30.795 25.0342 29.8525L24.6119 29.6696C24.313 31.7019 23.9622 33.6664 23.6178 35.6581L24.0597 35.719L23.9817 33.4835C23.9817 33.2667 23.6633 33.138 23.5594 33.3616C23.1661 34.2445 22.9452 35.2001 22.9097 36.1729C22.9113 36.2353 22.9358 36.2946 22.9781 36.3387C23.0204 36.3828 23.0773 36.4083 23.1371 36.41H23.1955C23.8531 36.1094 24.3791 35.5633 24.6704 34.879C25.0552 34.1025 25.3706 33.2907 25.6125 32.4538C26.1105 30.7205 26.452 28.9424 26.6325 27.1427C26.7495 26.1198 26.847 25.1104 26.9314 24.0807H26.4831L26.5286 26.3434C26.5286 26.4063 26.5525 26.4666 26.5952 26.511C26.6378 26.5555 26.6957 26.5805 26.756 26.5805C26.8163 26.5805 26.8741 26.5555 26.9168 26.511C26.9594 26.4666 26.9834 26.4063 26.9834 26.3434L26.9314 24.0807C26.937 24.0467 26.9354 24.0118 26.9267 23.9785C26.918 23.9452 26.9024 23.9143 26.8811 23.8879C26.8597 23.8615 26.8331 23.8403 26.8031 23.8258C26.7731 23.8112 26.7404 23.8037 26.7073 23.8037C26.6742 23.8037 26.6415 23.8112 26.6114 23.8258C26.5814 23.8403 26.5548 23.8615 26.5335 23.8879C26.5121 23.9143 26.4965 23.9452 26.4878 23.9785C26.4792 24.0118 26.4775 24.0467 26.4831 24.0807C26.1842 27.4679 25.8334 30.9838 24.4885 34.1271C24.2543 34.8933 23.741 35.533 23.0591 35.9087L23.345 36.1323C23.376 35.2388 23.5793 34.361 23.9427 33.5513L23.5269 33.4293L23.6049 35.6784C23.6049 35.929 24.0012 36.0103 24.0532 35.7394C24.417 33.7545 24.7484 31.7561 25.0472 29.7576C25.0576 29.7042 25.0501 29.6487 25.0258 29.6004C25.0015 29.5521 24.962 29.514 24.914 29.4925C24.8659 29.471 24.8122 29.4675 24.7619 29.4824C24.7116 29.4974 24.6678 29.53 24.6379 29.5747C24.0927 30.5431 23.5961 31.5402 23.15 32.5622L23.5724 32.6841C23.6151 31.4619 23.8184 30.2516 24.1766 29.087C24.4659 27.8787 24.4793 26.6164 24.2156 25.4017L23.8063 25.5914C24.2291 26.5724 24.2618 27.688 23.8972 28.6941C23.4964 29.7811 23.2427 30.9212 23.1436 32.0812C23.1436 32.298 23.4684 32.4199 23.5659 32.1964C24.391 30.3267 24.2156 28.2063 24.9498 26.3027L24.5145 26.174L23.8647 30.4418C23.7824 31.1016 23.6609 31.7555 23.5009 32.3996C23.3248 32.9991 23.0851 33.5763 22.7862 34.1203C22.4574 34.6947 22.2368 35.3293 22.1365 35.99L22.5783 35.929L22.5003 35.6716C22.4159 35.3871 21.9806 35.5158 22.0715 35.8003L22.078 35.8139Z"
      fill="white"
    />
    <path
      d="M21.0385 32.8797C20.4126 34.827 19.6234 36.7131 18.68 38.516C18.5436 38.7801 18.9334 39.0173 19.0699 38.7531C20.0356 36.9162 20.8381 34.991 21.4673 33.0017C21.5648 32.7171 21.1295 32.5952 21.0385 32.8797Z"
      fill="white"
    />
    <path
      d="M20.2782 33.2396L19.5765 35.3464L19.2256 36.3625L19.0502 36.8706L18.9463 37.1619L18.9008 37.3042C18.8553 37.3787 18.8618 37.3922 18.9008 37.3584L19.1217 37.4193C18.9268 37.189 18.6084 37.521 18.8033 37.7445C18.845 37.7871 18.9009 37.8114 18.9593 37.8122H19.0177C19.1802 37.7716 19.2386 37.6429 19.2971 37.5006C19.3556 37.3584 19.4271 37.1145 19.4985 36.918L19.9079 35.7258C20.1742 34.9399 20.4406 34.1473 20.7005 33.3615C20.7915 33.0702 20.3562 32.9483 20.2652 33.2328L20.2782 33.2396Z"
      fill="white"
    />
    <path
      d="M19.9729 33.4692C19.8196 34.1708 19.4848 34.8151 19.0048 35.3322C18.5359 35.8573 18.146 36.4534 17.8483 37.1003C17.8452 37.1205 17.8452 37.141 17.8483 37.1612C17.8477 37.2128 17.8632 37.2632 17.8925 37.3048C17.9218 37.3464 17.9633 37.3768 18.0107 37.3916H18.0757C18.1241 37.3916 18.1714 37.376 18.211 37.3469C18.2505 37.3178 18.2805 37.2766 18.2966 37.229C18.8164 35.8741 20.2003 35.0883 20.4212 33.5979C20.4212 33.5979 20.4212 33.5573 20.4212 33.537C20.4208 33.4856 20.4049 33.4357 20.3758 33.3944C20.3466 33.353 20.3057 33.3223 20.2588 33.3066H20.2003C20.1527 33.307 20.1065 33.3228 20.068 33.352C20.0296 33.3812 20.0008 33.4222 19.9859 33.4692H19.9729Z"
      fill="white"
    />
    <path
      d="M19.9142 33.5305L18.6148 35.7457C18.5846 35.7987 18.5759 35.862 18.5905 35.9217C18.6052 35.9814 18.6419 36.0326 18.6928 36.0641C18.7436 36.0955 18.8043 36.1046 18.8616 36.0894C18.9189 36.0741 18.968 36.0358 18.9981 35.9828L20.2976 33.7744C20.447 33.5169 20.0572 33.2798 19.9077 33.5373L19.9142 33.5305Z"
      fill="white"
    />
    <path
      d="M45.299 49.0373C43.4863 50.7309 42.0504 52.9394 39.8479 54.1181C39.588 54.2536 39.8479 54.66 40.0753 54.5245C42.3168 53.3323 43.7722 51.09 45.6109 49.3693C45.8318 49.1661 45.5134 48.8409 45.2925 49.0373H45.299Z"
      fill="white"
    />
    <path
      d="M44.0064 51.1237C42.4525 52.7464 40.527 53.9286 38.4123 54.5583C38.1394 54.6531 38.2628 55.107 38.5292 55.0122C40.7171 54.3501 42.7101 53.1247 44.3247 51.4489C44.5196 51.2253 44.2013 50.8934 44.0064 51.1169V51.1237Z"
      fill="white"
    />
    <path
      d="M44.5713 50.4117L44.4413 50.5877L44.4803 50.5403C44.4024 50.6486 44.3179 50.7502 44.2334 50.8517C44.1925 50.8952 44.1693 50.9534 44.1685 51.0142C44.1701 51.0769 44.1932 51.1369 44.2334 51.1835C44.2751 51.2261 44.331 51.2503 44.3894 51.2512C44.4475 51.249 44.5029 51.225 44.5453 51.1835C44.6882 51.0075 44.8182 50.8247 44.9546 50.6486C44.9637 50.6086 44.9637 50.5668 44.9546 50.5268C44.9578 50.5066 44.9578 50.486 44.9546 50.4658C44.9379 50.4067 44.9009 50.3561 44.8507 50.3236C44.8123 50.313 44.772 50.313 44.7337 50.3236H44.6752H44.6233C44.5911 50.3434 44.5643 50.3714 44.5453 50.4049L44.5713 50.4117Z"
      fill="white"
    />
    <path
      d="M45.3118 49.112C45.1791 49.4077 45.0294 49.6948 44.8635 49.9718C44.8547 50.0073 44.8547 50.0446 44.8635 50.0801C44.8629 50.1204 44.8721 50.1602 44.8903 50.1957C44.9084 50.2313 44.935 50.2614 44.9675 50.2833C45.0037 50.2933 45.0418 50.2933 45.0779 50.2833C45.1164 50.2828 45.1541 50.2727 45.188 50.2538C45.222 50.235 45.2511 50.2079 45.2729 50.1749C45.4363 49.8965 45.586 49.6095 45.7212 49.3151C45.7308 49.2774 45.7308 49.2377 45.7212 49.2C45.7252 49.1799 45.7252 49.1591 45.7212 49.1391C45.715 49.1088 45.7024 49.0804 45.6844 49.0559C45.6665 49.0313 45.6435 49.0111 45.6172 48.9969C45.5832 48.9867 45.5472 48.9867 45.5133 48.9969C45.4748 48.9974 45.4371 49.0075 45.4032 49.0263C45.3692 49.0452 45.3402 49.0722 45.3183 49.1052L45.3118 49.112Z"
      fill="white"
    />
    <path
      d="M30.4203 24.8864C29.6472 27.6884 29.1274 30.5597 28.8674 33.4627L30.6347 33.212L30.5177 32.4804C30.3293 31.2949 28.5686 31.803 28.783 32.9817L28.8999 33.7133C29.0753 34.8243 30.5762 34.4314 30.6607 33.4627C30.9121 30.7283 31.4103 28.0246 32.1485 25.3877C32.191 25.1555 32.1481 24.9151 32.0284 24.7144C31.9088 24.5136 31.721 24.3671 31.5026 24.304C31.2841 24.2409 31.0508 24.2657 30.8491 24.3736C30.6474 24.4815 30.492 24.6645 30.4138 24.8864H30.4203Z"
      fill="white"
    />
    <path
      d="M29.8356 25.45V36.5396H31.6353C31.5899 35.2728 32.1161 33.918 32.3695 32.6986L33.2271 28.8711C33.2796 28.6532 33.2556 28.4229 33.1594 28.2219C33.0633 28.0208 32.9014 27.8622 32.703 27.7747C32.5045 27.6872 32.2826 27.6765 32.0773 27.7447C31.872 27.8128 31.6968 27.9552 31.5834 28.1462C30.7813 29.5748 30.1092 31.0785 29.5757 32.6376L31.3365 32.8883C31.2063 30.3478 31.3107 27.8003 31.6483 25.2807C31.7263 24.5423 30.8362 24.1629 30.3034 24.4745C29.9712 24.7033 29.689 25.0026 29.4752 25.3528C29.2613 25.7029 29.1207 26.0962 29.0624 26.5068C28.788 27.5544 28.5711 28.6174 28.4127 29.6908C28.0879 31.8315 27.9254 33.9925 27.763 36.1467H29.5562C29.3741 33.3943 29.4852 30.6292 29.8876 27.9024C30.0045 26.8998 28.6596 26.7439 28.2178 27.4349C27.5551 28.4985 27.3992 29.9414 27.1718 31.2082C26.8859 32.685 26.6325 34.1618 26.4116 35.6522L28.1723 35.8961C27.9892 32.7463 28.1286 29.5851 28.5881 26.4662C28.7051 25.4162 27.0483 25.1994 26.8209 26.2155C26.496 27.672 26.2297 29.1421 26.0023 30.6256C25.9579 30.842 25.9875 31.0678 26.086 31.2638C26.1845 31.4599 26.3456 31.6138 26.5415 31.6991C26.7373 31.7843 26.9556 31.7954 27.1585 31.7305C27.3614 31.6656 27.5362 31.5288 27.6525 31.3437L29.0494 29.264C29.5498 28.6828 29.9578 28.0218 30.2579 27.3062C30.6543 25.8633 28.7896 24.8268 28.1009 26.2765C27.5436 27.627 27.2055 29.0647 27.1003 30.5308C27.0028 31.3098 26.9249 32.0957 26.7884 32.8612C26.7105 33.3218 26.7884 33.437 26.3661 33.6809C26.0203 33.9057 25.6574 34.1006 25.2811 34.2634L26.3726 34.4125C26.1647 34.1347 26.4116 33.0576 26.4311 32.7528L26.561 30.8085C26.6325 29.8127 25.346 29.623 24.8912 30.3411C23.9942 31.9103 23.2353 33.5609 22.6237 35.2728L24.2545 35.9503C24.657 34.4208 25.1987 32.935 25.8723 31.5131L24.2025 31.0456C24.0965 32.1468 23.9119 33.2383 23.6503 34.3109C23.6113 34.5419 23.6565 34.7798 23.777 34.978C23.8975 35.1761 24.0845 35.3202 24.3016 35.3821C24.5186 35.444 24.75 35.4191 24.9504 35.3125C25.1508 35.2058 25.3058 35.025 25.385 34.8054C25.5421 34.3785 25.7288 33.9642 25.9438 33.5657L24.9302 33.9992L25.1641 34.0941L24.5144 33.1863V33.4505C24.5126 35.2567 24.3407 37.0582 24.0011 38.8293L25.7684 39.08C25.8606 36.6487 26.1125 34.2269 26.522 31.8315C26.6715 30.673 25.1121 30.1311 24.7873 31.3302C24.235 33.4031 23.6568 35.476 23.124 37.5558C22.6562 39.3848 22.7472 41.18 24.1181 42.5688C24.2157 42.669 24.3338 42.7447 24.4636 42.7903C24.5934 42.8358 24.7315 42.85 24.8673 42.8317C25.0031 42.8134 25.1332 42.7632 25.2476 42.6848C25.3621 42.6064 25.458 42.5018 25.528 42.3791C26.0083 41.4175 26.4167 40.4187 26.7494 39.3916L25.8853 40.069C25.7424 40.069 25.8853 40.069 25.9958 40.191C26.1062 40.3129 26.2946 40.4823 26.4441 40.6381C26.5935 40.7939 26.9054 41.1326 27.0938 41.3833C27.5895 41.96 28.1307 42.4926 28.7116 42.9752C29.8746 43.8898 31.5184 43.2462 32.8308 43.0362C33.8964 42.8601 33.526 41.2816 32.5904 41.1936C31.2907 41.0729 30.0606 40.5277 29.0754 39.6355L28.6791 41.1936C28.9307 41.1327 29.1921 41.1302 29.4448 41.1864C29.6974 41.2426 29.9351 41.3561 30.141 41.5187C30.7907 41.9997 31.6288 41.2071 31.4404 40.462L31.0701 38.66L29.5692 39.5677L32.6164 43.463C32.7573 43.6072 32.9393 43.6998 33.135 43.7267C33.3308 43.7536 33.5296 43.7133 33.7014 43.612L33.9094 43.5036C34.0455 43.424 34.1589 43.308 34.2377 43.1675C34.3165 43.0269 34.3579 42.867 34.3577 42.7043C34.1303 39.2155 33.2207 35.6454 33.9938 32.1702L32.2201 31.8857L32.0706 35.6319L31.9992 37.5083L31.9667 38.2874C31.9667 38.4568 31.8108 39.229 32.0187 38.9648L33.5195 39.3781C33.3246 37.8198 33.3246 36.2417 33.5195 34.6835C33.6235 33.0915 33.7729 31.5063 33.9873 29.9414C34.0399 29.6993 34.002 29.4454 33.8812 29.2314C33.7605 29.0175 33.5661 28.8595 33.3376 28.7898C33.2224 28.7582 33.1024 28.7507 32.9844 28.7677C32.8664 28.7847 32.7528 28.8259 32.6501 28.8889C32.5475 28.9518 32.4578 29.0353 32.3862 29.1346C32.3146 29.2339 32.2626 29.3469 32.2331 29.4672C31.9992 31.215 31.8108 32.9628 31.7068 34.7241C31.5063 36.451 31.5238 38.1978 31.7588 39.92C31.8018 40.0769 31.8832 40.2195 31.995 40.3337C32.1068 40.4479 32.2452 40.5299 32.3965 40.5716C32.5479 40.6132 32.707 40.6132 32.8583 40.5714C33.0096 40.5296 33.1479 40.4475 33.2596 40.3332C34.0068 39.3374 33.7534 37.6777 33.7989 36.4786L33.9873 31.9466C33.978 31.7263 33.8948 31.5164 33.7522 31.3535C33.6097 31.1906 33.4168 31.0851 33.2073 31.0553C32.9977 31.0254 32.7848 31.0732 32.6056 31.1903C32.4263 31.3074 32.2922 31.4864 32.2266 31.696C31.4014 35.3744 32.2786 39.0393 32.5254 42.7314L32.9738 41.9184L32.7658 42.0268L33.8574 42.1759L30.8037 38.2806C30.2059 37.5083 29.1144 38.3551 29.3028 39.1884L29.7122 41.0039L31.0116 39.9471C30.4344 39.544 29.7571 39.3251 29.0624 39.3171C28.7688 39.3174 28.4763 39.3561 28.1918 39.4323C28.0413 39.4771 27.9046 39.562 27.795 39.6786C27.6855 39.7951 27.6069 39.9394 27.5669 40.0972C27.5269 40.255 27.527 40.4209 27.5671 40.5787C27.6071 40.7364 27.6859 40.8806 27.7955 40.9971C29.1292 42.2251 30.81 42.967 32.5839 43.1107L32.3695 41.2275L31.2455 41.4104C30.8796 41.5201 30.502 41.5816 30.1215 41.5933C29.6082 41.5187 29.1664 40.9158 28.822 40.5297C28.0294 39.6829 27.1198 38.2196 25.8723 38.1858C25.6785 38.1906 25.491 38.2585 25.336 38.3799C25.1811 38.5014 25.0664 38.6704 25.0082 38.8632C24.7278 39.74 24.3801 40.5918 23.9686 41.4104L25.3785 41.2207C24.1441 39.9742 24.7288 38.3687 25.1576 36.8648L26.522 31.8247L24.7808 31.3302C24.3578 33.8926 24.0995 36.4816 24.0076 39.08C24.0076 40.1029 25.5669 40.3874 25.7749 39.3239C26.1538 37.3659 26.3453 35.3735 26.3466 33.376V33.1863C26.344 32.9837 26.2796 32.7872 26.1628 32.6252C26.046 32.4633 25.8828 32.3442 25.6969 32.2853L25.463 32.1905C25.2726 32.1352 25.0699 32.147 24.8866 32.2242C24.7033 32.3014 24.5496 32.4396 24.4494 32.6173C24.1597 33.159 23.91 33.7229 23.7022 34.3041L25.437 34.8054C25.7335 33.5679 25.9399 32.3088 26.0542 31.0389C26.0482 30.8368 25.9799 30.6422 25.8595 30.4837C25.7391 30.3252 25.573 30.2114 25.3857 30.1589C25.1985 30.1065 25 30.1183 24.8197 30.1926C24.6394 30.2669 24.4868 30.3997 24.3845 30.5714C23.6208 32.1357 23.005 33.7738 22.5457 35.4625C22.2729 36.4583 23.7672 37.1832 24.1895 36.1874C24.8109 34.4862 25.5739 32.845 26.4701 31.2827L24.7938 30.8153C24.7288 31.7569 24.6573 32.7053 24.5989 33.6538C24.5458 34.021 24.5657 34.3958 24.6573 34.7547C24.749 35.1137 24.9104 35.4491 25.1316 35.7402C25.2725 35.8845 25.4545 35.9771 25.6502 36.0039C25.846 36.0308 26.0448 35.9906 26.2167 35.8893C27.0041 35.6275 27.7045 35.139 28.2373 34.4802C28.5485 33.75 28.7164 32.9623 28.7311 32.1634C28.9585 30.4089 29.0494 28.5798 29.7966 26.9607L29.2639 27.3943H29.4133L28.7181 27.2994C28.7181 26.7439 28.5946 26.622 28.4387 26.9878L28.1074 27.4756L27.4576 28.4511L26.1582 30.4021L27.802 31.1269C28.0294 29.6434 28.3023 28.1801 28.6206 26.7168L26.7819 26.4662C26.3233 29.5852 26.1817 32.746 26.3596 35.8961C26.4441 36.858 27.9579 37.2509 28.1268 36.1467C28.3348 34.7602 28.5687 33.3783 28.8285 32.0008C29.0494 30.8424 29.1534 29.4063 29.7966 28.4104L28.1203 27.943C27.727 30.6619 27.6268 33.4181 27.8215 36.1603C27.8215 36.4082 27.9159 36.646 28.0841 36.8213C28.2522 36.9966 28.4803 37.0951 28.7181 37.0951C28.9559 37.0951 29.1839 36.9966 29.3521 36.8213C29.5202 36.646 29.6147 36.4082 29.6147 36.1603C29.7446 34.3651 29.8681 32.5699 30.115 30.7882C30.2254 29.955 30.3619 29.1285 30.5308 28.3088C30.6478 27.7669 30.7452 26.3917 31.252 26.1004L29.9006 25.2875C29.5631 27.807 29.4587 30.3546 29.5887 32.895C29.5938 33.1189 29.6752 33.3336 29.8183 33.5005C29.9615 33.6674 30.157 33.7757 30.3698 33.8059C30.5827 33.8361 30.7988 33.7862 30.9796 33.6652C31.1603 33.5442 31.2937 33.36 31.356 33.1457C31.8439 31.7354 32.455 30.3748 33.1817 29.0811L31.5379 28.3562L30.6153 32.475C30.3229 33.7621 29.8161 35.1848 29.8681 36.5396C29.8681 36.7876 29.9626 37.0253 30.1307 37.2007C30.2989 37.376 30.5269 37.4745 30.7647 37.4745C31.0025 37.4745 31.2306 37.376 31.3987 37.2007C31.5669 37.0253 31.6613 36.7876 31.6613 36.5396V25.4568C31.6613 25.2089 31.5669 24.9711 31.3987 24.7958C31.2306 24.6205 31.0025 24.522 30.7647 24.522C30.5269 24.522 30.2989 24.6205 30.1307 24.7958C29.9626 24.9711 29.8681 25.2089 29.8681 25.4568L29.8356 25.45Z"
      fill="white"
    />
    <path
      d="M20.3887 33.5379C20.0339 34.8213 19.5998 36.0794 19.0892 37.3044L20.733 37.528C20.6096 37.0605 20.9994 36.1731 21.1424 35.7192C21.329 35.094 21.5458 34.479 21.7921 33.8766C22.2469 32.7995 20.8435 31.8443 20.2457 32.9282L18.5695 35.8818L20.1938 36.627C20.3454 35.8914 20.6468 35.1984 21.0774 34.5947L19.5311 33.6463C18.994 34.6669 18.446 35.6605 17.8873 36.627C17.828 36.7333 17.7893 36.8507 17.7736 36.9726C17.7578 37.0945 17.7652 37.2184 17.7954 37.3373C17.8255 37.4562 17.8779 37.5677 17.9494 37.6655C18.0209 37.7633 18.1102 37.8455 18.2121 37.9073C18.3141 37.9692 18.4267 38.0094 18.5436 38.0259C18.6605 38.0423 18.7794 38.0346 18.8934 38.0031C19.0074 37.9717 19.1144 37.9171 19.2082 37.8426C19.302 37.768 19.3808 37.6749 19.4401 37.5686C20.0119 36.5931 20.5619 35.5995 21.0904 34.5879C21.1876 34.375 21.2047 34.1318 21.1383 33.9064C21.0718 33.681 20.9266 33.4898 20.7315 33.3706C20.5363 33.2514 20.3054 33.2129 20.0843 33.2627C19.8632 33.3125 19.6681 33.4469 19.5376 33.6395C19.0154 34.3731 18.6479 35.2134 18.459 36.1054C18.4095 36.3225 18.4355 36.551 18.5325 36.75C18.6295 36.949 18.7912 37.1056 18.9886 37.1918C19.1861 37.2781 19.4065 37.2884 19.6106 37.2209C19.8147 37.1534 19.9891 37.0126 20.1028 36.8234L21.7791 33.9173L20.2263 32.9688C19.865 33.7988 19.5546 34.6518 19.2972 35.5228C18.9651 36.3218 18.8505 37.2007 18.9658 38.0631C19.1542 38.7812 20.2652 39.0454 20.6096 38.2867C21.2023 36.9175 21.7101 35.5101 22.1299 34.0731C22.4613 32.9147 20.7265 32.4201 20.3952 33.5718L20.3887 33.5379Z"
      fill="white"
    />
    <path
      d="M21.0254 34.4511C21.06 37.1969 21.0211 39.936 20.9084 42.6683H22.7017C22.7773 41.1817 23.1964 39.7361 23.9231 38.4547L22.2794 38.2311C22.5851 39.0337 22.7481 39.8877 22.7601 40.7512C22.7637 40.7736 22.7637 40.7965 22.7601 40.8189C22.7664 40.8729 22.7664 40.9275 22.7601 40.9815C22.7082 41.2254 22.8056 41.1644 23.046 40.8054C22.8863 40.766 22.7228 40.7455 22.5587 40.7444H22.1949C21.8989 40.7454 21.6035 40.7703 21.3113 40.8189C20.5635 40.9606 19.8392 41.2139 19.1607 41.5709C18.3549 41.9262 17.4887 42.1083 16.6138 42.1061C16.376 42.1061 16.1479 42.2046 15.9798 42.3799C15.8116 42.5552 15.7172 42.793 15.7172 43.0409C15.7172 43.2889 15.8116 43.5266 15.9798 43.702C16.1479 43.8773 16.376 43.9758 16.6138 43.9758C17.1985 43.9758 17.7053 44.2264 18.2641 43.8809C18.7598 43.4514 19.1779 42.9329 19.4986 42.3499C20.1093 41.5031 18.7579 40.4192 18.0887 41.2118L17.9522 41.3677C17.4194 41.9977 17.9522 43.3187 18.8293 42.9325C19.4271 42.6751 20.0118 42.4041 20.5836 42.0993L19.2841 41.537C19.505 42.5735 19.8494 43.7658 20.9149 44.1248L21.1553 42.2822C20.4082 42.2144 19.6545 42.1806 18.9073 42.1806H18.2576C17.8158 42.1806 17.3805 42.2212 16.9581 42.2619C16.562 42.3531 16.1498 42.3344 15.7627 42.2077C14.7426 41.6454 13.8135 43.2577 14.8596 43.8267C15.7692 44.3348 16.7048 44.1384 17.6923 44.0842C18.1082 44.0842 18.537 44.0842 18.9528 44.0842C19.7 44.0842 20.4471 44.1248 21.1878 44.1925C22.2404 44.2806 22.3508 42.6616 21.4282 42.3499C21.2788 42.2957 21.0904 41.2254 21.0579 41.0696C21.019 40.9353 20.952 40.8116 20.8617 40.7075C20.7714 40.6035 20.6601 40.5216 20.5358 40.4678C20.4115 40.414 20.2773 40.3897 20.1428 40.3965C20.0084 40.4033 19.8771 40.4412 19.7584 40.5073C19.3166 40.7444 18.8813 40.9612 18.459 41.1847L19.3361 42.7428L19.4661 42.587L17.9652 41.3677L17.6209 41.8351C17.5624 41.9231 17.1855 42.289 17.4065 42.2144C17.6274 42.1399 17.257 42.1264 17.1855 42.1128C17.0027 42.0836 16.8182 42.0677 16.6333 42.0654V43.9351C17.6939 43.9366 18.7453 43.7297 19.7325 43.3254C20.6839 42.7868 21.766 42.5513 22.8446 42.648C25.3915 42.9596 24.5534 39.1863 24.0401 37.7231C23.987 37.5505 23.888 37.3972 23.7545 37.2811C23.621 37.1651 23.4586 37.091 23.2862 37.0675C23.1139 37.0441 22.9387 37.0723 22.7811 37.1488C22.6235 37.2253 22.4901 37.3469 22.3963 37.4995C21.5068 39.0676 20.992 40.8357 20.8954 42.6548C20.8954 43.8606 22.6432 43.8538 22.6952 42.6548C22.7991 39.918 22.8381 37.1789 22.8121 34.4375C22.793 34.2024 22.6898 33.9834 22.5232 33.8238C22.3566 33.6642 22.1385 33.5757 21.9123 33.5757C21.686 33.5757 21.468 33.6642 21.3013 33.8238C21.1347 33.9834 21.0316 34.2024 21.0124 34.4375L21.0254 34.4511Z"
      fill="white"
    />
    <path
      d="M44.974 50.0937H45.052L44.5972 49.965L44.6622 50.0057L44.4738 48.5356C44.1364 48.8352 43.8175 49.1565 43.5187 49.4976L43.1418 49.965C43.0635 50.0876 42.9589 50.1896 42.8365 50.2631C42.7337 50.3241 42.6436 50.4059 42.5715 50.5036C42.4994 50.6013 42.4467 50.713 42.4164 50.8322C42.3862 50.9514 42.379 51.0757 42.3954 51.1978C42.4117 51.3199 42.4512 51.4374 42.5116 51.5434C42.6357 51.7533 42.8327 51.905 43.0616 51.9669C43.2904 52.0287 43.5334 51.996 43.7396 51.8754C44.1268 51.6428 44.4596 51.3235 44.7142 50.9405C45.0345 50.5613 45.382 50.208 45.7537 49.8837C45.851 49.7826 45.9247 49.6595 45.9692 49.524C46.0136 49.3884 46.0275 49.2441 46.01 49.102C45.9924 48.9599 45.9437 48.824 45.8678 48.7047C45.7918 48.5853 45.6905 48.4858 45.5718 48.4137C45.3891 48.3055 45.184 48.245 44.974 48.2376C44.8554 48.2367 44.7379 48.2602 44.628 48.3067C44.5181 48.3532 44.418 48.4218 44.3335 48.5086C44.2491 48.5954 44.1818 48.6987 44.1357 48.8126C44.0895 48.9265 44.0653 49.0488 44.0644 49.1724C44.0694 49.4187 44.1655 49.6535 44.3326 49.8277C44.4996 50.0019 44.7248 50.1021 44.9611 50.1073L44.974 50.0937Z"
      fill="white"
    />
    <path
      d="M44.2206 49.2536C44.2199 49.4219 44.2616 49.5873 44.3414 49.7335C44.4212 49.8798 44.5363 50.0016 44.6754 50.0869C44.8204 50.1711 44.9837 50.2153 45.1497 50.2153C45.3157 50.2153 45.479 50.1711 45.624 50.0869L44.5325 48.6169L43.337 49.7888C43.2472 49.8751 43.1756 49.9798 43.1266 50.0964C43.0775 50.213 43.0522 50.3389 43.0522 50.4662C43.0522 50.5935 43.0775 50.7195 43.1266 50.8361C43.1756 50.9527 43.2472 51.0574 43.337 51.1437C43.4221 51.233 43.5234 51.3039 43.6349 51.3522C43.7464 51.4006 43.8659 51.4255 43.9867 51.4255C44.1075 51.4255 44.2271 51.4006 44.3386 51.3522C44.4501 51.3039 44.5513 51.233 44.6364 51.1437L45.8384 49.9785C45.9213 49.8885 45.9864 49.7824 46.0299 49.6661C46.0733 49.5499 46.0944 49.4258 46.0918 49.3011C46.0914 49.0938 46.0276 48.8922 45.9099 48.7252C45.7748 48.5376 45.5779 48.4089 45.3571 48.3638C45.1363 48.3188 44.9073 48.3607 44.7144 48.4814H45.598L46.0463 49.2875C46.0463 49.0396 45.9519 48.8018 45.7837 48.6265C45.6156 48.4512 45.3875 48.3527 45.1497 48.3527C44.9119 48.3527 44.6839 48.4512 44.5157 48.6265C44.3476 48.8018 44.2531 49.0396 44.2531 49.2875L44.2206 49.2536Z"
      fill="white"
    />
    <path
      d="M18.1148 42.6414C18.3525 42.6414 18.5806 42.5429 18.7488 42.3677C18.9169 42.1925 19.0114 41.9548 19.0114 41.707C19.0114 41.4592 18.9169 41.2216 18.7488 41.0464C18.5806 40.8711 18.3525 40.7727 18.1148 40.7727C17.877 40.7727 17.6489 40.8711 17.4808 41.0464C17.3126 41.2216 17.2181 41.4592 17.2181 41.707C17.2181 41.9548 17.3126 42.1925 17.4808 42.3677C17.6489 42.5429 17.877 42.6414 18.1148 42.6414Z"
      fill="white"
    />
    <path
      d="M19.3751 37.7041L19.4661 37.4805V37.2299V36.9792C19.4515 36.9329 19.4342 36.8877 19.4141 36.8437C19.4081 36.7703 19.395 36.6977 19.3751 36.627V36.5795L19.4661 36.8031V37.047V37.2976L19.3751 37.5279L19.2387 37.7176L19.0567 37.8667L18.8423 37.9615C19.0636 37.8873 19.2524 37.7337 19.3751 37.5279C19.4414 37.4259 19.4776 37.3057 19.479 37.1825C19.4848 37.1307 19.4848 37.0784 19.479 37.0266C19.4783 36.9531 19.4673 36.8801 19.4466 36.8099C19.3849 36.5724 19.2353 36.3701 19.0307 36.2476C18.892 36.1661 18.7352 36.1241 18.5759 36.1257C18.4983 36.1157 18.4197 36.1157 18.342 36.1257C18.2224 36.158 18.1113 36.2183 18.0172 36.3018C17.9179 36.3713 17.8355 36.4641 17.7768 36.5728C17.7349 36.652 17.7022 36.7361 17.6793 36.8234V37.0741C17.6855 37.2545 17.7322 37.4308 17.8158 37.5889C17.8368 37.6157 17.8543 37.6453 17.8677 37.677L17.7768 37.4534V37.2028V36.9521L17.8612 36.7286C17.7831 36.8757 17.7429 37.0414 17.7443 37.2096C17.7344 37.2882 17.7344 37.368 17.7443 37.4467C17.7747 37.5642 17.8302 37.6731 17.9067 37.765C17.9695 37.8662 18.0569 37.948 18.1601 38.0021C18.2984 38.0857 18.4551 38.13 18.6149 38.1309C18.7719 38.1309 18.9261 38.0877 19.0618 38.0057C19.1976 37.9236 19.3102 37.8055 19.3881 37.6634L19.3751 37.7041Z"
      fill="white"
    />
    <path
      d="M19.6999 36.999C19.6999 36.9515 19.7714 36.8093 19.6999 36.9244C19.7462 36.8278 19.8029 36.7369 19.8688 36.6535C19.9925 36.49 20.1054 36.318 20.2067 36.1386C20.3218 35.9228 20.3522 35.6689 20.2916 35.4302C20.2311 35.1915 20.0842 34.9865 19.8818 34.8583C19.7795 34.7965 19.6665 34.7565 19.5493 34.7404C19.4321 34.7243 19.313 34.7326 19.1989 34.7647C19.0848 34.7968 18.9779 34.8521 18.8843 34.9275C18.7908 35.0028 18.7125 35.0967 18.6539 35.2038C18.357 35.6179 18.1185 36.0741 17.9457 36.5586C17.9032 36.7908 17.9461 37.0312 18.0657 37.232C18.1854 37.4327 18.3731 37.5792 18.5916 37.6424C18.8101 37.7055 19.0433 37.6806 19.245 37.5727C19.4467 37.4648 19.6022 37.2818 19.6804 37.0599L19.6999 36.999Z"
      fill="white"
    />
    <path
      d="M19.4467 33.9497V33.9971C19.4558 34.2485 19.5502 34.4884 19.7131 34.6741C19.8823 34.8281 20.0936 34.9229 20.3173 34.9449H20.5577C20.7064 34.9056 20.8415 34.8235 20.9475 34.708L21.0905 34.5184C21.1698 34.3765 21.2123 34.2155 21.2139 34.0512V34.0038C21.2077 33.7518 21.1129 33.5109 20.9475 33.3268C20.87 33.2384 20.7714 33.173 20.6617 33.1372C20.5639 33.0822 20.4543 33.0543 20.3433 33.056H20.1029C19.9529 33.0968 19.8161 33.1786 19.7066 33.293L19.5636 33.4825C19.4874 33.6258 19.4451 33.7859 19.4402 33.9497H19.4467Z"
      fill="white"
    />
    <path
      d="M14.5739 43.1435C14.5478 43.2451 14.5347 43.3499 14.5349 43.4551C14.5361 43.579 14.5536 43.702 14.5869 43.8209C14.6135 43.938 14.6696 44.0456 14.7493 44.1326C14.8138 44.2338 14.9007 44.3175 15.0027 44.3764C15.1006 44.4456 15.2158 44.4833 15.3341 44.4848C15.3837 44.4914 15.4339 44.4914 15.4835 44.4848C15.5525 44.4951 15.6225 44.4951 15.6914 44.4848L15.9058 44.39C16.0414 44.3097 16.1537 44.1927 16.2307 44.0513L16.3216 43.8277C16.3649 43.6659 16.3649 43.4949 16.3216 43.3332V43.2654V43.5161V43.4009V43.6448C16.3341 43.5754 16.3341 43.5042 16.3216 43.4348C16.3249 43.3807 16.3249 43.3264 16.3216 43.2722C16.3158 43.1487 16.2776 43.0292 16.2112 42.9267C16.1593 42.8191 16.0808 42.7279 15.9838 42.6625C15.9004 42.5794 15.7972 42.5209 15.6849 42.4932H15.4445C15.2869 42.4948 15.1324 42.5392 14.9962 42.6219L14.8273 42.7235C14.7123 42.8384 14.6293 42.9835 14.5869 43.1435H14.5739Z"
      fill="white"
    />
  </svg>
);

const wallet = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3334 9.70276V6.66276C27.3334 5.19609 26.1334 3.99609 24.6667 3.99609H6.00004C4.52004 3.99609 3.33337 5.19609 3.33337 6.66276V25.3294C3.33337 26.7961 4.52004 27.9961 6.00004 27.9961H24.6667C26.1334 27.9961 27.3334 26.7961 27.3334 25.3294V22.2894C28.12 21.8228 28.6667 20.9828 28.6667 19.9961V11.9961C28.6667 11.0094 28.12 10.1694 27.3334 9.70276ZM26 11.9961V19.9961H16.6667V11.9961H26ZM6.00004 25.3294V6.66276H24.6667V9.32943H16.6667C15.2 9.32943 14 10.5294 14 11.9961V19.9961C14 21.4628 15.2 22.6628 16.6667 22.6628H24.6667V25.3294H6.00004Z"
      fill="#169FED"
    />
    <path
      d="M20.6667 17.9961C21.7713 17.9961 22.6667 17.1007 22.6667 15.9961C22.6667 14.8915 21.7713 13.9961 20.6667 13.9961C19.5621 13.9961 18.6667 14.8915 18.6667 15.9961C18.6667 17.1007 19.5621 17.9961 20.6667 17.9961Z"
      fill="#169FED"
    />
  </svg>
);

const partners = ({ size, color, ...props }: IconPropTypes) => (
  <Partner size={size ?? 32} color={color} />
);

const home = ({ size, color, ...props }: IconPropTypes) => (
  <Home size={size ?? 32} color={color} />
);
const activity = ({ size, color, ...props }: IconPropTypes) => (
  <Activity size={size} color={color} />
);
const teacher = ({ size, color, ...props }: IconPropTypes) => (
  <Teacher size={size} color={color} />
);

const profile = ({ size, color, ...props }: IconPropTypes) => (
  <Profile size={size} color={color} />
);

const eye = ({ size, color, ...props }: IconPropTypes) => (
  <Eye size={size} color={color} />
);

const replay = ({ size, color, ...props }: IconPropTypes) => (
  <Replay size={size} color={color} />
);

const message = () => (
  <svg width="62" height="58" viewBox="0 0 62 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* <rect
      x="0.942424"
      y="1.66972"
      width="54.6606"
      height="54.6606"
      rx="27.3303"
      stroke="#E1E8ED"
      strokeWidth="1.88485"
    /> */}
    <path
      d="M24.3145 36.8591H23.7491C19.2254 36.8591 16.9636 35.7316 16.9636 30.094V24.4563C16.9636 19.9462 19.2254 17.6912 23.7491 17.6912H32.7964C37.32 17.6912 39.5818 19.9462 39.5818 24.4563V30.094C39.5818 34.6041 37.32 36.8591 32.7964 36.8591H32.2309C31.8803 36.8591 31.541 37.0282 31.3262 37.3101L29.6298 39.5652C28.8834 40.5574 27.662 40.5574 26.9156 39.5652L25.2193 37.3101C25.0383 37.0621 24.6199 36.8591 24.3145 36.8591Z"
      stroke="#808080"
      strokeWidth="2.26182"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.7919 27.8386H32.8026"
      stroke="#808080"
      strokeWidth="2.26182"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.2672 27.8386H28.278"
      stroke="#808080"
      strokeWidth="2.26182"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7424 27.8384H23.7532"
      stroke="#808080"
      strokeWidth="2.26182"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="42.3444" cy="15.95077" r="7.22323" fill="#169FED" />
  </svg>
);

const downArrow = () => (
  <svg
    width="24"
    height="14"
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5151 2.28816L12.0909 11.7124L2.66665 2.28816"
      stroke="#169FED"
      strokeWidth="3.7697"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const egg = () => (
  <svg
    width="31"
    height="40"
    viewBox="0 0 31 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6697 0.612793C8.13028 0.612793 0.590881 14.2483 0.590881 24.308C0.590881 32.6445 7.33325 39.3868 15.6697 39.3868C24.0061 39.3868 30.7485 32.6445 30.7485 24.308C30.7485 14.2483 23.2091 0.612793 15.6697 0.612793ZM15.6697 35.0786C9.72432 35.0786 4.89911 30.2534 4.89911 24.308C4.89911 15.4977 11.5122 4.92102 15.6697 4.92102C19.8271 4.92102 26.4402 15.4977 26.4402 24.308C26.4402 30.2534 21.615 35.0786 15.6697 35.0786Z"
      fill="#169FED"
    />
    <path
      d="M17.8238 28.6163C16.5744 28.6163 11.3614 28.4439 11.3614 22.1539C11.3614 20.9692 10.3921 19.9998 9.20733 19.9998C8.02257 19.9998 7.05322 20.9692 7.05322 22.1539C7.05322 28.6163 11.3399 32.9245 17.8238 32.9245C19.0085 32.9245 19.9779 31.9551 19.9779 30.7704C19.9779 29.5856 19.0085 28.6163 17.8238 28.6163Z"
      fill="#169FED"
    />
  </svg>
);

const star = () => (
  <svg
    width="31"
    height="40"
    viewBox="0 0 31 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4089 22.2429L15.7818 18.9255L20.1358 22.2429L18.4771 16.871L22.85 13.4029H17.497L15.7818 8.1065L14.0666 13.4029H8.71361L13.0676 16.871L11.4089 22.2429ZM30.8606 15.2878C30.8606 6.95674 24.1128 0.208984 15.7818 0.208984C7.45076 0.208984 0.703007 6.95674 0.703007 15.2878C0.703007 19.114 2.13549 22.5821 4.4727 25.2398V39.7908L15.7818 36.0211L27.0909 39.7908V25.2398C29.4281 22.5821 30.8606 19.114 30.8606 15.2878ZM15.7818 3.97868C22.0206 3.97868 27.0909 9.04892 27.0909 15.2878C27.0909 21.5266 22.0206 26.5969 15.7818 26.5969C9.54295 26.5969 4.4727 21.5266 4.4727 15.2878C4.4727 9.04892 9.54295 3.97868 15.7818 3.97868ZM15.7818 32.2514L8.2424 34.174V28.3309C10.4665 29.6126 13.0299 30.3666 15.7818 30.3666C18.5337 30.3666 21.0971 29.6126 23.3212 28.3309V34.174L15.7818 32.2514Z"
      fill="#1177B2"
    />
  </svg>
);

const camera = () => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 7.81996L10.4745 10.0672L8.22725 11.0927L10.4745 12.1181L11.5 14.3654L12.5254 12.1181L14.7727 11.0927L12.5254 10.0672L11.5 7.81996ZM20.2272 2.36541H16.7691L14.7727 0.183594H8.22725L6.23088 2.36541H2.7727C1.5727 2.36541 0.590881 3.34723 0.590881 4.54723V17.6381C0.590881 18.8381 1.5727 19.82 2.7727 19.82H20.2272C21.4272 19.82 22.4091 18.8381 22.4091 17.6381V4.54723C22.4091 3.34723 21.4272 2.36541 20.2272 2.36541ZM20.2272 17.6381H2.7727V4.54723H7.19088L7.83452 3.83814L9.18725 2.36541H13.8127L15.1654 3.83814L15.8091 4.54723H20.2272V17.6381ZM11.5 5.63814C8.48906 5.63814 6.04543 8.08178 6.04543 11.0927C6.04543 14.1036 8.48906 16.5472 11.5 16.5472C14.5109 16.5472 16.9545 14.1036 16.9545 11.0927C16.9545 8.08178 14.5109 5.63814 11.5 5.63814ZM11.5 14.3654C9.69997 14.3654 8.22725 12.8927 8.22725 11.0927C8.22725 9.29269 9.69997 7.81996 11.5 7.81996C13.3 7.81996 14.7727 9.29269 14.7727 11.0927C14.7727 12.8927 13.3 14.3654 11.5 14.3654Z"
      fill="white"
    />
  </svg>
);

const caret_left = () => (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.809167 7.86082L6.78379 0.387409C7.19674 -0.129136 7.86449 -0.129136 8.27305 0.387409L9.26589 1.62931C9.67884 2.14586 9.67884 2.98112 9.26589 3.49217L5.03533 8.795L9.27029 14.0923C9.68324 14.6089 9.68324 15.4441 9.27029 15.9552L8.27744 17.2026C7.86449 17.7191 7.19674 17.7191 6.78818 17.2026L0.81356 9.72918C0.396215 9.21263 0.396215 8.37737 0.809167 7.86082Z"
      fill="white"
    />
  </svg>
);

const caret_right = ({ color }: IconPropTypes) => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L9 9L2 16"
      stroke={color ?? "#808080"}
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const caret_right_bold = () => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.73087 9.9341L3.75625 17.4075C3.3433 17.9241 2.67555 17.9241 2.26699 17.4075L1.27415 16.1656C0.861194 15.6491 0.861194 14.8138 1.27415 14.3027L5.50471 8.99992L1.26975 3.70259C0.856801 3.18605 0.856801 2.35078 1.26975 1.83973L2.26259 0.59233C2.67554 0.0757853 3.3433 0.0757853 3.75186 0.59233L9.72648 8.06574C10.1438 8.58229 10.1438 9.41755 9.73087 9.9341Z"
      fill="white"
    />
  </svg>
);

const plus_in_circle = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3334 9.33463H14.6667V14.668H9.33335V17.3346H14.6667V22.668H17.3334V17.3346H22.6667V14.668H17.3334V9.33463ZM16 2.66797C8.64002 2.66797 2.66669 8.6413 2.66669 16.0013C2.66669 23.3613 8.64002 29.3346 16 29.3346C23.36 29.3346 29.3334 23.3613 29.3334 16.0013C29.3334 8.6413 23.36 2.66797 16 2.66797ZM16 26.668C10.12 26.668 5.33335 21.8813 5.33335 16.0013C5.33335 10.1213 10.12 5.33464 16 5.33464C21.88 5.33464 26.6667 10.1213 26.6667 16.0013C26.6667 21.8813 21.88 26.668 16 26.668Z"
      fill="#169FED"
    />
  </svg>
);

const settings = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4986 9.85857C15.5336 9.57877 15.5598 9.29897 15.5598 9.00167C15.5598 8.70438 15.5336 8.42458 15.4986 8.14478L17.3436 6.70204C17.5097 6.57088 17.5534 6.3348 17.4485 6.14243L15.6997 3.11706C15.621 2.97715 15.4724 2.89846 15.315 2.89846C15.2625 2.89846 15.2101 2.9072 15.1664 2.92469L12.9891 3.79908C12.5345 3.44932 12.0448 3.16077 11.5114 2.94218L11.1792 0.625055C11.1529 0.415202 10.9693 0.257812 10.7507 0.257812H7.25317C7.03457 0.257812 6.85095 0.415202 6.82472 0.625055L6.49246 2.94218C5.95908 3.16077 5.46942 3.45807 5.01474 3.79908L2.83752 2.92469C2.78506 2.9072 2.7326 2.89846 2.68013 2.89846C2.53149 2.89846 2.38284 2.97715 2.30415 3.11706L0.555374 6.14243C0.441703 6.3348 0.494167 6.57088 0.6603 6.70204L2.50525 8.14478C2.47028 8.42458 2.44405 8.71313 2.44405 9.00167C2.44405 9.29022 2.47028 9.57877 2.50525 9.85857L0.6603 11.3013C0.494167 11.4325 0.450447 11.6686 0.555374 11.8609L2.30415 14.8863C2.38284 15.0262 2.53149 15.1049 2.68888 15.1049C2.74134 15.1049 2.7938 15.0961 2.83752 15.0787L5.01474 14.2043C5.46942 14.554 5.95908 14.8426 6.49246 15.0612L6.82472 17.3783C6.85095 17.5881 7.03457 17.7455 7.25317 17.7455H10.7507C10.9693 17.7455 11.1529 17.5881 11.1792 17.3783L11.5114 15.0612C12.0448 14.8426 12.5345 14.5453 12.9891 14.2043L15.1664 15.0787C15.2188 15.0961 15.2713 15.1049 15.3238 15.1049C15.4724 15.1049 15.621 15.0262 15.6997 14.8863L17.4485 11.8609C17.5534 11.6686 17.5097 11.4325 17.3436 11.3013L15.4986 9.85857ZM13.7673 8.36337C13.8023 8.63443 13.8111 8.81805 13.8111 9.00167C13.8111 9.1853 13.7936 9.37766 13.7673 9.63998L13.6449 10.628L14.4231 11.2401L15.3675 11.9746L14.7554 13.0326L13.6449 12.5867L12.7356 12.2194L11.9486 12.814C11.5726 13.0938 11.2141 13.3037 10.8556 13.4523L9.92879 13.8283L9.78889 14.8163L9.61401 15.9968H8.38987L8.08384 13.8283L7.15699 13.4523C6.781 13.2949 6.43125 13.0938 6.08149 12.8315L5.2858 12.2194L4.35895 12.5954L3.24848 13.0413L2.63641 11.9833L3.58075 11.2488L4.35895 10.6368L4.23654 9.64872C4.21031 9.37766 4.19282 9.17655 4.19282 9.00167C4.19282 8.8268 4.21031 8.62569 4.23654 8.36337L4.35895 7.37532L3.58075 6.76325L2.63641 6.02876L3.24848 4.97075L4.35895 5.41669L5.26831 5.78393L6.05526 5.18935C6.43125 4.90955 6.78975 4.69969 7.14824 4.55105L8.07509 4.17506L8.215 3.18701L8.38987 2.00658H9.60527L9.91131 4.17506L10.8382 4.55105C11.2141 4.70844 11.5639 4.90955 11.9136 5.17186L12.7093 5.78393L13.6362 5.40795L14.7467 4.96201L15.3587 6.02002L14.4231 6.76325L13.6449 7.37532L13.7673 8.36337ZM9.00194 5.50413C7.06955 5.50413 5.5044 7.06928 5.5044 9.00167C5.5044 10.9341 7.06955 12.4992 9.00194 12.4992C10.9343 12.4992 12.4995 10.9341 12.4995 9.00167C12.4995 7.06928 10.9343 5.50413 9.00194 5.50413ZM9.00194 10.7504C8.04012 10.7504 7.25317 9.9635 7.25317 9.00167C7.25317 8.03985 8.04012 7.2529 9.00194 7.2529C9.96377 7.2529 10.7507 8.03985 10.7507 9.00167C10.7507 9.9635 9.96377 10.7504 9.00194 10.7504Z"
      fill="#169FED"
    />
  </svg>
);

const contact = () => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4948 9.22C19.4948 3.73 15.2348 0 10.4948 0C5.80475 0 1.49475 3.65 1.49475 9.28C0.894751 9.62 0.494751 10.26 0.494751 11V13C0.494751 14.1 1.39475 15 2.49475 15H3.49475V8.9C3.49475 5.03 6.62475 1.9 10.4948 1.9C14.3648 1.9 17.4948 5.03 17.4948 8.9V16H9.49475V18H17.4948C18.5948 18 19.4948 17.1 19.4948 16V14.78C20.0848 14.47 20.4948 13.86 20.4948 13.14V10.84C20.4948 10.14 20.0848 9.53 19.4948 9.22Z"
      fill="#169FED"
    />
    <path
      d="M7.49475 11C8.04704 11 8.49475 10.5523 8.49475 10C8.49475 9.44771 8.04704 9 7.49475 9C6.94247 9 6.49475 9.44771 6.49475 10C6.49475 10.5523 6.94247 11 7.49475 11Z"
      fill="#169FED"
    />
    <path
      d="M13.4948 11C14.047 11 14.4948 10.5523 14.4948 10C14.4948 9.44771 14.047 9 13.4948 9C12.9425 9 12.4948 9.44771 12.4948 10C12.4948 10.5523 12.9425 11 13.4948 11Z"
      fill="#169FED"
    />
    <path
      d="M16.4948 8.03C16.0148 5.18 13.5348 3 10.5448 3C7.51475 3 4.25475 5.51 4.51475 9.45C6.98475 8.44 8.84475 6.24 9.37475 3.56C10.6848 6.19 13.3748 8 16.4948 8.03Z"
      fill="#169FED"
    />
  </svg>
);

const logout = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9392 4.44444L11.6859 5.69778L13.0903 7.11111H5.82808V8.88889H13.0903L11.6859 10.2933L12.9392 11.5556L16.4948 8L12.9392 4.44444ZM2.27253 1.77778H8.49475V0H2.27253C1.29475 0 0.494751 0.8 0.494751 1.77778V14.2222C0.494751 15.2 1.29475 16 2.27253 16H8.49475V14.2222H2.27253V1.77778Z"
      fill="#FF5252"
    />
  </svg>
);

const lens = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6922 13.6776L17 16.7972M8.42857 4.54165C10.3221 4.54165 11.8571 6.03811 11.8571 7.88409M15.9333 8.4783C15.9333 12.4984 12.5904 15.7574 8.46667 15.7574C4.34294 15.7574 1 12.4984 1 8.4783C1 4.45817 4.34294 1.19922 8.46667 1.19922C12.5904 1.19922 15.9333 4.45817 15.9333 8.4783Z"
      stroke="black"
      stroke-width="1.8881"
      stroke-linecap="round"
    />
  </svg>
);

const school = () => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1268 4.81689L1.54346 13.3169L7.21012 16.4052V24.9052L17.1268 30.3169L27.0435 24.9052V16.4052L29.8768 14.8611V24.6502H32.7101V13.3169L17.1268 4.81689ZM26.7885 13.3169L17.1268 18.5869L7.46512 13.3169L17.1268 8.04689L26.7885 13.3169ZM24.2101 23.2194L17.1268 27.0869L10.0435 23.2194V17.9494L17.1268 21.8169L24.2101 17.9494V23.2194Z"
      fill="#169FED"
    />
  </svg>
);

const phone = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_899_5925)">
      <path
        d="M11.9101 1.00781H6.09002C4.88236 1.00781 3.9075 1.98267 3.9075 3.19033V14.8304C3.9075 16.0381 4.88236 17.0129 6.09002 17.0129H11.9101C13.1177 17.0129 14.0926 16.0381 14.0926 14.8304V3.19033C14.0926 1.98267 13.1177 1.00781 11.9101 1.00781ZM10.455 15.5579H7.54502V14.8304H10.455V15.5579ZM12.8194 13.3754H5.18063V3.19033H12.8194V13.3754Z"
        fill="#169FED"
      />
    </g>
    <defs>
      <clipPath id="clip0_899_5925">
        <rect
          width="17.4601"
          height="17.4601"
          fill="white"
          transform="translate(0.269958 0.273438)"
        />
      </clipPath>
    </defs>
  </svg>
);

const envelope = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_901_1280)">
      <path
        d="M16.2751 3.17969H1.73225L1.72498 14.8198H16.2751V3.17969ZM14.8201 13.3648H3.17999V6.08971L9.00002 9.72723L14.8201 6.08971V13.3648ZM9.00002 8.27222L3.17999 4.6347H14.8201L9.00002 8.27222Z"
        fill="#169FED"
      />
    </g>
    <defs>
      <clipPath id="clip0_901_1280">
        <rect
          width="17.4601"
          height="17.4601"
          fill="white"
          transform="translate(0.269958 0.273438)"
        />
      </clipPath>
    </defs>
  </svg>
);

const whatsapp = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.882968 17.7336C0.720585 17.7336 0.566298 17.6686 0.452631 17.555C0.298368 17.4007 0.233456 17.1735 0.290289 16.9624L1.3133 13.1392C0.6313 11.8729 0.274035 10.4443 0.274035 8.99942C0.274035 4.18594 4.18744 0.273438 9.00204 0.273438C13.8167 0.273438 17.7301 4.18594 17.7301 8.99942C17.7301 13.8129 13.8167 17.7254 9.00204 17.7254C7.53248 17.7254 6.09546 17.3602 4.81264 16.6621L1.04536 17.7092C0.988524 17.7254 0.939801 17.7336 0.882968 17.7336ZM4.8938 15.4039C4.99935 15.4039 5.10491 15.4365 5.20234 15.4852C6.34713 16.1589 7.66239 16.516 9.00204 16.516C13.1428 16.516 16.5122 13.1473 16.5122 9.00754C16.5122 4.86779 13.1428 1.49915 9.00204 1.49915C4.86133 1.49915 1.4919 4.86779 1.4919 9.00754C1.4919 10.3306 1.84101 11.6213 2.49866 12.7577C2.57985 12.8957 2.60423 13.0662 2.56363 13.2204L1.75172 16.2562L4.73954 15.4283C4.78826 15.412 4.84509 15.4039 4.8938 15.4039Z"
      fill="#169FED"
    />
    <path
      d="M11.2267 13.6825C10.7234 13.6825 10.2037 13.5689 9.65976 13.3335C9.14825 13.1143 8.63675 12.8221 8.14148 12.4568C7.65434 12.0996 7.17537 11.6938 6.73694 11.2554C6.29851 10.809 5.89251 10.3382 5.53527 9.85116C5.16991 9.33978 4.87762 8.83651 4.66653 8.34136C4.43919 7.80563 4.32553 7.27801 4.32553 6.77474C4.32553 6.41758 4.39047 6.07666 4.51225 5.76009C4.64216 5.42728 4.85326 5.12693 5.12931 4.86718C5.64894 4.3558 6.39593 4.16912 6.98862 4.45322C7.1916 4.54251 7.3621 4.68862 7.49204 4.88343L8.43377 6.20653C8.5312 6.3364 8.60435 6.47439 8.66119 6.61239C8.72614 6.77473 8.76674 6.93709 8.76674 7.09132C8.76674 7.30237 8.70982 7.51341 8.59615 7.7001C8.52308 7.82186 8.41753 7.96797 8.27951 8.10596L8.17396 8.2196C8.22268 8.28454 8.27951 8.36571 8.36882 8.46312C8.53932 8.65793 8.72606 8.86898 8.92904 9.07191C9.13202 9.26672 9.33499 9.46154 9.53797 9.632C9.6354 9.71317 9.71667 9.77811 9.78162 9.8187L9.89521 9.70505C10.0414 9.55895 10.1876 9.4453 10.3337 9.37225C10.6017 9.20179 11.0156 9.1612 11.381 9.31543C11.5109 9.36413 11.6408 9.43719 11.7788 9.53459L13.1348 10.4924C13.3216 10.6223 13.4676 10.8009 13.565 11.0038C13.6462 11.2067 13.6788 11.3853 13.6788 11.572C13.6788 11.8155 13.6219 12.0509 13.5163 12.2782C13.4108 12.4893 13.289 12.676 13.1429 12.8464C12.883 13.1305 12.5827 13.3416 12.2579 13.4796C11.9332 13.6176 11.584 13.6825 11.2267 13.6825ZM6.39589 5.54903C6.34718 5.54903 6.18484 5.54903 5.98186 5.75196C5.8276 5.89807 5.72202 6.05231 5.64895 6.22278C5.57588 6.39324 5.5434 6.58805 5.5434 6.78286C5.5434 7.12379 5.62458 7.48905 5.78696 7.87868C5.95746 8.28454 6.20918 8.71475 6.5177 9.14497C6.83435 9.57518 7.19159 10.0054 7.58947 10.4031C7.9873 10.7928 8.40941 11.158 8.84785 11.4827C9.27004 11.7912 9.70043 12.0347 10.1307 12.2214C10.7478 12.4893 11.3161 12.5542 11.7788 12.3594C11.9412 12.2944 12.0874 12.1808 12.2335 12.0347C12.3066 11.9535 12.3635 11.8724 12.4122 11.7668C12.4366 11.71 12.4527 11.6451 12.4527 11.5882C12.4527 11.572 12.4527 11.5477 12.4284 11.499L11.0725 10.5574C11.0156 10.5168 10.9588 10.4843 10.9101 10.4681C10.8776 10.4843 10.829 10.5087 10.7397 10.5979L10.4312 10.9064C10.1957 11.1418 9.82222 11.2067 9.52181 11.1012L9.37567 11.0363C9.18893 10.9389 8.97775 10.7928 8.7423 10.5898C8.51496 10.395 8.29583 10.1921 8.06037 9.96481C7.83304 9.72941 7.63006 9.51024 7.4352 9.28296C7.22407 9.03133 7.07792 8.8284 6.98049 8.65793L6.8912 8.44689C6.86684 8.36571 6.85869 8.27642 6.85869 8.19525C6.85869 7.96797 6.93991 7.76504 7.09418 7.6027L7.40273 7.28612C7.49204 7.19683 7.52451 7.14814 7.54075 7.11567C7.5164 7.05885 7.48392 7.01014 7.44332 6.95332L6.49332 5.61398L6.39589 5.54903Z"
      fill="#169FED"
    />
  </svg>
);

const x_logo = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4426 7.85102L16.0812 1.4375H14.7452L9.84695 7.00511L5.93758 1.4375H1.42755L7.3406 9.85746L1.42755 16.5824H2.76355L7.93305 10.7015L12.0624 16.5824H16.5725L10.4426 7.85102ZM8.61211 9.93137L8.01208 9.09241L3.24535 2.42303H5.29772L9.14575 7.80743L9.74325 8.64639L14.7446 15.6449H12.6922L8.61211 9.93137Z"
      fill="#169FED"
    />
  </svg>
);

const instagram = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.59797 3.47823V14.5288C2.59797 15.0137 2.99 15.4055 3.47475 15.4055H14.5253C15.0102 15.4055 15.4021 15.0135 15.4021 14.5288V3.47823C15.4021 2.99333 15.01 2.60145 14.5253 2.60145H3.47475C2.98985 2.60145 2.59797 2.99348 2.59797 3.47823ZM0.269958 3.47823C0.269958 1.70797 1.70391 0.273438 3.47475 0.273438H14.5253C16.2955 0.273438 17.7301 1.70739 17.7301 3.47823V14.5288C17.7301 16.299 16.2961 17.7336 14.5253 17.7336H3.47475C1.70449 17.7336 0.269958 16.2996 0.269958 14.5288V3.47823Z"
      fill="#169FED"
    />
    <path
      d="M9.29102 13.0739C7.20171 13.0739 5.508 11.3801 5.508 9.29084C5.508 7.20153 7.20171 5.50781 9.29102 5.50781C11.3803 5.50781 13.074 7.20153 13.074 9.29084C13.074 11.3801 11.3803 13.0739 9.29102 13.0739ZM9.29102 10.7458C10.0946 10.7458 10.746 10.0944 10.746 9.29084C10.746 8.48726 10.0946 7.83583 9.29102 7.83583C8.48744 7.83583 7.83601 8.48726 7.83601 9.29084C7.83601 10.0944 8.48744 10.7458 9.29102 10.7458Z"
      fill="#169FED"
    />
    <path
      d="M13.365 5.51164C13.8472 5.51164 14.238 5.12078 14.238 4.63863C14.238 4.15648 13.8472 3.76562 13.365 3.76562C12.8829 3.76562 12.492 4.15648 12.492 4.63863C12.492 5.12078 12.8829 5.51164 13.365 5.51164Z"
      fill="#169FED"
    />
  </svg>
);

const linkedin = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.720032 5.13281H4.12203V16.0206H0.720032V5.13281Z"
      fill="#169FED"
    />
    <path
      d="M2.34934 -0.0078125C1.09489 -0.0078125 0.269958 0.803486 0.269958 1.88067C0.269958 2.93741 1.06762 3.76915 2.30161 3.76915H2.32888C3.6106 3.76915 4.40826 2.93059 4.40144 1.88067C4.37417 0.803486 3.60378 -0.0078125 2.34934 -0.0078125Z"
      fill="#169FED"
    />
    <path
      d="M13.4145 5.02344C11.4647 5.02344 10.2443 6.08699 10.0193 6.83693V5.1257H6.19464C6.24236 6.03245 6.19464 16.0135 6.19464 16.0135H10.0193V10.1298C10.0193 9.79578 10.0057 9.46853 10.1011 9.23673C10.3602 8.58224 10.9261 7.90048 11.9419 7.90048C13.2713 7.90048 13.8713 8.90949 13.8713 10.3821V16.0135H17.7301V9.9594C17.7301 6.59149 15.8348 5.02344 13.4145 5.02344Z"
      fill="#169FED"
    />
  </svg>
);

const facebook = () => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.72637 17.3873V8.98319H10.38L10.9573 6.19814H6.72637V4.80164C6.72637 4.07493 7.04029 3.38132 8.41454 3.38132H11.1613V0.601562H7.26177C3.9831 0.601562 3.08844 2.24029 3.08844 4.51175V6.19681H0.838715V8.98319H3.08844V17.3873H6.72637Z"
      fill="#169FED"
    />
  </svg>
);

const play = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0C7.16129 0 0 7.3848 0 16.4994C0 25.6139 7.16129 32.9987 16 32.9987C24.8387 32.9987 32 25.6139 32 16.4994C32 7.3848 24.8387 0 16 0ZM23.4645 18.0961L12.1097 24.8156C11.0903 25.4011 9.80645 24.6493 9.80645 23.4185V9.58028C9.80645 8.35613 11.0839 7.5977 12.1097 8.18316L23.4645 15.3018C24.5226 15.9139 24.5226 17.4907 23.4645 18.0961Z"
      fill="currentColor"
    />
  </svg>
);

const chalkboard = () => (
  <svg
    width="36"
    height="29"
    viewBox="0 0 36 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8467 19.6664C11.7162 19.6664 11.5858 19.6855 11.4613 19.7259C10.7539 19.9557 10.01 20.1031 9.22669 20.1031C8.44342 20.1031 7.69945 19.9557 6.9915 19.7259C6.86705 19.6855 6.73715 19.6664 6.60669 19.6664C3.21926 19.6664 0.475362 22.4218 0.493374 25.8136C0.501016 27.2469 1.67947 28.3997 3.11337 28.3997H15.34C16.7739 28.3997 17.9524 27.2469 17.96 25.8136C17.978 22.4218 15.2341 19.6664 11.8467 19.6664ZM9.22669 17.9197C12.1207 17.9197 14.4667 15.5738 14.4667 12.6798C14.4667 9.78576 12.1207 7.43977 9.22669 7.43977C6.33268 7.43977 3.9867 9.78576 3.9867 12.6798C3.9867 15.5738 6.33268 17.9197 9.22669 17.9197ZM32.8066 0.453125H11.8467C10.4019 0.453125 9.22669 1.6676 9.22669 3.15991V5.69311C10.505 5.69311 11.6884 6.06319 12.72 6.66469V3.94645H31.9333V19.6664H28.44V16.1731H21.4533V19.6664H17.2919C18.3344 20.5774 19.0997 21.7804 19.4583 23.1597H32.8066C34.2514 23.1597 35.4266 21.9453 35.4266 20.453V3.15991C35.4266 1.6676 34.2514 0.453125 32.8066 0.453125Z"
      fill="#169FED"
    />
  </svg>
);

const check = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
  </svg>
);
const primaryCheck = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // {...props}
  >
    <path
      d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zM9.6 18l-6-6 1.692-1.692L9.6 14.604l9.108-9.108L20.4 7.2 9.6 18z"
      fill="#148FD5"
    />
  </svg>
);

const checkGray = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.5C5.376 0.5 0 5.876 0 12.5C0 19.124 5.376 24.5 12 24.5C18.624 24.5 24 19.124 24 12.5C24 5.876 18.624 0.5 12 0.5ZM9.6 18.5L3.6 12.5L5.292 10.808L9.6 15.104L18.708 5.996L20.4 7.7L9.6 18.5Z"
      fill="#E1E8ED"
    />
  </svg>
);
const checkBlue = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.5C5.376 0.5 0 5.876 0 12.5C0 19.124 5.376 24.5 12 24.5C18.624 24.5 24 19.124 24 12.5C24 5.876 18.624 0.5 12 0.5ZM9.6 18.5L3.6 12.5L5.292 10.808L9.6 15.104L18.708 5.996L20.4 7.7L9.6 18.5Z"
      fill="#148FD5"
    />
  </svg>
);

const share = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 19.4933C18.9867 19.4933 18.08 19.8933 17.3867 20.52L7.88 14.9866C7.94667 14.68 8 14.3733 8 14.0533C8 13.7333 7.94667 13.4266 7.88 13.12L17.28 7.63997C18 8.30664 18.9467 8.71997 20 8.71997C22.2133 8.71997 24 6.9333 24 4.71997C24 2.50664 22.2133 0.719971 20 0.719971C17.7867 0.719971 16 2.50664 16 4.71997C16 5.03997 16.0533 5.34664 16.12 5.6533L6.72 11.1333C6 10.4666 5.05333 10.0533 4 10.0533C1.78667 10.0533 0 11.84 0 14.0533C0 16.2666 1.78667 18.0533 4 18.0533C5.05333 18.0533 6 17.64 6.72 16.9733L16.2133 22.52C16.1467 22.8 16.1067 23.0933 16.1067 23.3866C16.1067 25.5333 17.8533 27.28 20 27.28C22.1467 27.28 23.8933 25.5333 23.8933 23.3866C23.8933 21.24 22.1467 19.4933 20 19.4933ZM20 3.38664C20.7333 3.38664 21.3333 3.98664 21.3333 4.71997C21.3333 5.4533 20.7333 6.0533 20 6.0533C19.2667 6.0533 18.6667 5.4533 18.6667 4.71997C18.6667 3.98664 19.2667 3.38664 20 3.38664ZM4 15.3866C3.26667 15.3866 2.66667 14.7866 2.66667 14.0533C2.66667 13.32 3.26667 12.72 4 12.72C4.73333 12.72 5.33333 13.32 5.33333 14.0533C5.33333 14.7866 4.73333 15.3866 4 15.3866ZM20 24.7466C19.2667 24.7466 18.6667 24.1466 18.6667 23.4133C18.6667 22.68 19.2667 22.08 20 22.08C20.7333 22.08 21.3333 22.68 21.3333 23.4133C21.3333 24.1466 20.7333 24.7466 20 24.7466Z"
      fill="#169FED"
    />
  </svg>
);

const meet = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <rect
      width="16"
      height="16"
      x="12"
      y="16"
      fill="#fff"
      transform="rotate(-90 20 24)"
    ></rect>
    <polygon fill="#1e88e5" points="3,17 3,31 8,32 13,31 13,17 8,16"></polygon>
    <path
      fill="#4caf50"
      d="M37,24v14c0,1.657-1.343,3-3,3H13l-1-5l1-5h14v-7l5-1L37,24z"
    ></path>
    <path
      fill="#fbc02d"
      d="M37,10v14H27v-7H13l-1-5l1-5h21C35.657,7,37,8.343,37,10z"
    ></path>
    <path fill="#1565c0" d="M13,31v10H6c-1.657,0-3-1.343-3-3v-7H13z"></path>
    <polygon fill="#e53935" points="13,7 13,17 3,17"></polygon>
    <polygon fill="#2e7d32" points="38,24 37,32.45 27,24 37,15.55"></polygon>
    <path
      fill="#4caf50"
      d="M46,10.11v27.78c0,0.84-0.98,1.31-1.63,0.78L37,32.45v-16.9l7.37-6.22C45.02,8.8,46,9.27,46,10.11z"
    ></path>
  </svg>
);
const Zoom = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <circle cx="24" cy="24" r="20" fill="#2196f3"></circle>
    <path
      fill="#fff"
      d="M29,31H14c-1.657,0-3-1.343-3-3V17h15c1.657,0,3,1.343,3,3V31z"
    ></path>
    <polygon fill="#fff" points="37,31 31,27 31,21 37,17"></polygon>
  </svg>
);

const teams = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <path
      fill="#5059c9"
      d="M44,22v8c0,3.314-2.686,6-6,6s-6-2.686-6-6V20h10C43.105,20,44,20.895,44,22z M38,16	c2.209,0,4-1.791,4-4c0-2.209-1.791-4-4-4s-4,1.791-4,4C34,14.209,35.791,16,38,16z"
    ></path>
    <path
      fill="#7b83eb"
      d="M35,22v11c0,5.743-4.841,10.356-10.666,9.978C19.019,42.634,15,37.983,15,32.657V20h18	C34.105,20,35,20.895,35,22z M25,17c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S21.686,17,25,17z"
    ></path>
    <circle cx="25" cy="11" r="6" fill="#7b83eb"></circle>
    <path
      d="M26,33.319V20H15v12.657c0,1.534,0.343,3.008,0.944,4.343h6.374C24.352,37,26,35.352,26,33.319z"
      opacity=".05"
    ></path>
    <path
      d="M15,20v12.657c0,1.16,0.201,2.284,0.554,3.343h6.658c1.724,0,3.121-1.397,3.121-3.121V20H15z"
      opacity=".07"
    ></path>
    <path
      d="M24.667,20H15v12.657c0,0.802,0.101,1.584,0.274,2.343h6.832c1.414,0,2.56-1.146,2.56-2.56V20z"
      opacity=".09"
    ></path>
    <linearGradient
      id="DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1"
      x1="4.648"
      x2="23.403"
      y1="14.648"
      y2="33.403"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#5961c3"></stop>
      <stop offset="1" stopColor="#3a41ac"></stop>
    </linearGradient>
    <path
      fill="url(#DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1)"
      d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
    ></path>
    <path
      fill="#fff"
      d="M18.068,18.999H9.932v1.72h3.047v8.28h2.042v-8.28h3.047V18.999z"
    ></path>
  </svg>
);
const edit = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <path d="M 36 5.0097656 C 34.205301 5.0097656 32.410791 5.6901377 31.050781 7.0507812 L 8.9160156 29.183594 C 8.4960384 29.603571 8.1884588 30.12585 8.0253906 30.699219 L 5.0585938 41.087891 A 1.50015 1.50015 0 0 0 6.9121094 42.941406 L 17.302734 39.974609 A 1.50015 1.50015 0 0 0 17.304688 39.972656 C 17.874212 39.808939 18.39521 39.50518 18.816406 39.083984 L 40.949219 16.949219 C 43.670344 14.228094 43.670344 9.7719064 40.949219 7.0507812 C 39.589209 5.6901377 37.794699 5.0097656 36 5.0097656 z M 36 7.9921875 C 37.020801 7.9921875 38.040182 8.3855186 38.826172 9.171875 A 1.50015 1.50015 0 0 0 38.828125 9.171875 C 40.403 10.74675 40.403 13.25325 38.828125 14.828125 L 36.888672 16.767578 L 31.232422 11.111328 L 33.171875 9.171875 C 33.957865 8.3855186 34.979199 7.9921875 36 7.9921875 z M 29.111328 13.232422 L 34.767578 18.888672 L 16.693359 36.962891 C 16.634729 37.021121 16.560472 37.065723 16.476562 37.089844 L 8.6835938 39.316406 L 10.910156 31.521484 A 1.50015 1.50015 0 0 0 10.910156 31.519531 C 10.933086 31.438901 10.975086 31.366709 11.037109 31.304688 L 29.111328 13.232422 z"></path>
  </svg>
);
const checks = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="20"
    height="20"
    viewBox="0,0,256,256"
  >
    <g
      fill="#169fed"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
    >
      <g transform="scale(10.66667,10.66667)">
        <path d="M11,16.4l-4.7,-4.7l1.4,-1.4l3.3,3.3l8.4,-8.4c-1.9,-1.9 -4.5,-3.2 -7.4,-3.2c-5.5,0 -10,4.5 -10,10c0,5.5 4.5,10 10,10c5.5,0 10,-4.5 10,-10c0,-1.9 -0.5,-3.6 -1.4,-5.1z"></path>
      </g>
    </g>
  </svg>
);
const subscription = () => (
  <svg
    width={181}
    height={180}
    viewBox="0 0 181 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // {...props}
  >
    <path
      d="M60.33 20.293S33.052 34.2 19.448 55.61C5.844 77.02 6.92 104.57 23.45 125.01c16.531 20.441 48.129 17.762 74.585 30.715 26.456 12.953 55.645 10.289 68.155-17.157 12.51-27.447-6.354-37.696-9.594-69.448-3.24-31.752-31.871-78.275-96.268-48.827z"
      fill="#169FED"
    />
    <path
      opacity={0.7}
      d="M60.33 20.293S33.052 34.2 19.448 55.61C5.844 77.02 6.92 104.57 23.45 125.01c16.531 20.441 48.129 17.762 74.585 30.715 26.456 12.953 55.645 10.289 68.155-17.157 12.51-27.447-6.354-37.696-9.594-69.448-3.24-31.752-31.871-78.275-96.268-48.827z"
      fill="#fff"
    />
    <path
      d="M10.941 164.175h157.011"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.781 151.524s-9.536-16.747-7.336-21.006c2.2-4.258 7.826 3.402 7.826 3.402s-4.892-15.613-2.2-22.428c2.693-6.814 7.334 0 7.56 4.828.227 4.828-.975 13.057-.975 13.057s1.955-17.031 6.599-11.923c4.644 5.108-5.868 22.144-5.868 22.144s7.092-3.96 6.84 1.137c-.252 5.098-8.558 9.652-8.558 9.652"
      fill="#169FED"
    />
    <path
      d="M26.865 148.403s-8.827-8.233-4.529-11.923c4.299-3.69 6.563 3.96 6.563 3.96s-4.752-23.562 2.945-24.416c7.697-.853 2.034 20.441 2.034 20.441s6.563-9.086 6.12-1.703c-.443 7.384-10.192 13.641-10.192 13.641M31.2 146.902l-5.966-6.462M29.957 147.402l1.613-18.889M29.703 146.035l5.346-7.085"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeMiterlimit={10}
    />
    <path
      d="M37.435 144.717H20.939l1.65 19.458h13.197l1.649-19.458z"
      fill="#2D2D2D"
    />
    <path
      d="M109.753 55.972a14.94 14.94 0 00-4.373-10.559 14.936 14.936 0 00-10.56-4.373h-5.198A14.932 14.932 0 0074.69 55.972"
      stroke="#2D2D2D"
      strokeWidth={1.08}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.752 67.032v-11.06M74.69 55.973v11.059"
      stroke="#2D2D2D"
      strokeWidth={2.16}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.414 83.624s.932 6.512.745 8.186c-.187 1.674-.558 3.348-5.21 1.487-4.65-1.861-13.02 1.49-18.417 7.999-5.396 6.509-15.624 28.278-15.624 30.881 0 2.603 2.045 6.12 5.76 6.696 3.715.576 12.463-10.044 12.463-10.044s3.72 21.02 3.72 22.68c0 1.66-1.668 12.65-1.668 12.65h52.647l-2.049-13.579 3.723-29.952s15.44 21.021 18.788 21.96c3.348.94 8.557-.745 9.861-4.651 1.303-3.906-.746-7.999-3.352-10.976-2.606-2.977-18.972-29.207-21.96-31.623-2.988-2.415-11.347-2.606-14.324-1.86-2.978.744-8 1.86-9.303 1.115-1.303-.745-1.3-7.812 0-10.976.011.007-11.336 2.984-15.8.007z"
      fill="#169FED"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.14 140.267c.6.231 1.212.432 1.833.601M68.541 128.333s.828 7.228 7.64 11.016M89.727 107.161l3.621 5.292M125.539 112.219l.958-1.994M123.988 109.667l-2.484 10.976 3.053-6.369M135.141 129.445s3.931-2.52 7.801-2.52"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M127.14 136.994a53.575 53.575 0 007.125-4.615 15.937 15.937 0 0111.34-3.211c3.711.4 5.72 5.015 5.817 9.634.098 4.618-2.408 7.423-6.922 8.125-4.515.702-9.836-.299-13.144-1.102a43.68 43.68 0 00-5.321-1.004s-4.313-6.624 1.105-7.827z"
      fill="#fff"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.423 138.802c-.097-4.619-2.106-9.234-5.817-9.634a15.937 15.937 0 00-11.34 3.211l-.504.385c4.32.148 13.053 1.912 11.685 13.976 3.917-.94 6.07-3.658 5.976-7.938z"
      fill="#169FED"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.415 83.624s.932 6.513.745 8.187c-.14 1.256-.385 2.52-2.459 2.275 2.967 4.85 11.581 16.232 19.62.72-.936.058-1.692 0-2.095-.223-1.3-.745-1.3-7.812 0-10.977 0 .018-11.347 2.996-15.811.018z"
      fill="#fff"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.414 83.624s.241 1.693.454 3.572a16.484 16.484 0 006.984 1.9 13.484 13.484 0 007.599-2.2c.12-1.118.38-2.217.774-3.272 0 0-11.347 2.978-15.81 0zM75.19 61.11h-1.027a2.282 2.282 0 00-2.282 2.282v8.734a2.282 2.282 0 002.282 2.282h1.026a2.282 2.282 0 002.283-2.282v-8.734a2.282 2.282 0 00-2.283-2.282z"
      fill="#2D2D2D"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.248 61.12H74.104v13.277H75.248V61.12z"
      fill="#fff"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M110.369 61.11h-1.026a2.282 2.282 0 00-2.282 2.282v8.734a2.282 2.282 0 002.282 2.282h1.026a2.282 2.282 0 002.282-2.282v-8.734a2.282 2.282 0 00-2.282-2.282z"
      fill="#2D2D2D"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M110.43 61.12h-1.145v13.277h1.145V61.12zM65.887 71.61A2.624 2.624 0 0063.803 73c-.835 1.39-3.474 6.53-3.197 8.06.277 1.53 11.812 12.367 11.812 13.062 0 .695-9.17 13.201-15.286 18.759-6.116 5.559-10.976 11.808-11.811 16.812-.836 5.004 2.084 9.169 5.144 10.005 3.06.835 6.807-.972 11.113-6.394 4.306-5.422 16.12-29.041 17.928-37.08 0 0 .414-3.6-1.253-5.699-1.666-2.099-5.835-6.948-5.835-6.948s.835-9.587.14-10.281c-.695-.695-1.39.835-1.39.835s-.644-3.215-1.53-3.06c-.968.173-1.249 1.39-1.249 1.39s-.694-2.798-2.502-.85z"
      fill="#fff"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.169 74.113s-1.995 7.981-1.8 9.327M68.39 72.443s-2.114 7.761-2.384 8.841a2.66 2.66 0 00.338 2.092M65.887 71.61s-2.985 8.324-2.985 9.202c0 .879.677 1.955.677 1.955"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.23 106.391a73.39 73.39 0 01-6.098 6.48c-6.12 5.554-10.976 11.808-11.811 16.812-.836 5.004 2.084 9.169 5.144 10.004 3.06.835 6.807-.972 11.113-6.394 2.48-3.117 7.441-12.261 11.552-20.998-6.263-1.664-8.848-4.256-9.9-5.904z"
      fill="#169FED"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.349 54.22s-.241 19.342.486 22.97c.727 3.63 7.254 9.793 14.76 10.034 7.506.241 13.421-6.65 14.144-10.278.724-3.629 0-18.133-.118-23.936-.119-5.804-8.464-11.002-16.92-9.674-8.457 1.329-12.834 6.286-12.352 10.883z"
      fill="#fff"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.728 62.078s.483 3.384.969 4.108c.486.723 1.328 1.695-.36 2.419-1.689.724-3.025-.123-3.025-.969"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M97.541 74.044s-6.53.835-9.432-2.044c0 0 .72 4.474 2.902 5.201 2.182.728 6.53-3.157 6.53-3.157z"
      fill="#fff"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M89.078 62.197l.605 1.933"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.418 64.012s1.692 1.08 4.835.118"
      stroke="#2D2D2D"
      strokeWidth={0.72}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.926 62.197l.605 1.933"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.266 64.012s1.692 1.08 4.838.118M85.572 58.813a6.342 6.342 0 015.076-2.538M97.178 56.03s3.506-.965 5.925 1.8"
      stroke="#2D2D2D"
      strokeWidth={0.72}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.66 61.2a3.34 3.34 0 01-.043 3.448l-.068.108a5.626 5.626 0 01-4.777 2.653h-.756a4.388 4.388 0 01-3.795-2.185 3.643 3.643 0 011.037-4.796 3.636 3.636 0 011.88-.665l3.44-.216A3.33 3.33 0 0192.66 61.2zM96.62 61.2a3.342 3.342 0 00.043 3.448l.069.108a5.627 5.627 0 004.777 2.653h.756a4.39 4.39 0 003.794-2.185 3.627 3.627 0 00.209-3.24 3.635 3.635 0 00-3.125-2.22l-3.438-.217A3.337 3.337 0 0096.62 61.2zM93.066 61.833s1.08-.846 3.143 0M91.615 60.023h5.926M83.005 61.981H77.35"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.993 49.14s3.132 10.058 7.887 12.657c-.104-3.448-.227-6.689-.27-8.787-.122-5.804-8.463-11.002-16.92-9.674-8.456 1.329-12.816 6.286-12.334 10.883 0 0-.04 3.157-.035 7.164 4.082-1.76 14.832-6.663 21.672-12.243z"
      fill="#2D2D2D"
    />
    <mask
      id="a"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={77}
      y={43}
      width={30}
      height={19}
    >
      <path
        d="M98.995 49.14s3.131 10.058 7.887 12.657c-.104-3.449-.227-6.689-.27-8.788-.122-5.803-8.463-11.001-16.92-9.673-8.456 1.328-12.816 6.286-12.333 10.883 0 0-.04 3.157-.036 7.164 4.082-1.76 14.832-6.664 21.672-12.244z"
        fill="#fff"
      />
    </mask>
    <g
      mask="url(#a)"
      stroke="#737373"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M76.512 58.74S92.37 52.09 100.94 43.65M75.23 53.37s16.629-3.838 26.223-13.944M102.09 44.797s.255 6.524 7.164 12.536" />
    </g>
    <path
      d="M100.288 85.388s0 4.385-3.287 11.373c-3.286 6.987-3.427 13.975-1.234 19.18 2.192 5.206 8.085 7.265 14.4 4.936 6.314-2.329 7.124-12.744 6.44-19.048-.684-6.303-6.84-13.701-8.222-17.402-1.383-3.7-2.329-5.616-2.329-5.616s-3.564 4.932-5.76 6.026l-.008.551z"
      fill="#2D2D2D"
    />
    <mask
      id="b"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={94}
      y={78}
      width={23}
      height={44}
    >
      <path
        d="M100.288 85.388s0 4.385-3.287 11.373c-3.286 6.987-3.427 13.975-1.234 19.18 2.192 5.206 8.085 7.265 14.4 4.936 6.314-2.329 7.124-12.744 6.44-19.048-.684-6.303-6.84-13.701-8.222-17.402-1.383-3.7-2.329-5.616-2.329-5.616s-3.564 4.932-5.76 6.026l-.008.551z"
        fill="#fff"
      />
    </mask>
    <g
      mask="url(#b)"
      stroke="#737373"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M102.599 80.485a34.414 34.414 0 01-2.3 17.64c-3.838 9.209-.896 19.059 3.582 21.104 4.478 2.044 8.824 1.281 10.998-1.534" />
      <path d="M104.262 78.44s4.349 10.232 2.559 17.907c-1.789 7.675-1.022 17.413 4.349 19.314 5.371 1.901 8.442-1.901 8.442-1.901" />
      <path d="M109.506 85.09s3.708 14.069 3.708 21.359c0 7.29 4.478 6.141 5.63 2.559" />
    </g>
    <path
      d="M100.288 85.388s0 4.385-3.287 11.373c-3.286 6.987-3.427 13.975-1.234 19.18 2.192 5.206 8.085 7.265 14.4 4.936 6.314-2.329 7.124-12.744 6.44-19.048-.684-6.303-6.84-13.701-8.222-17.402-1.383-3.7-2.329-5.616-2.329-5.616s-3.564 4.932-5.76 6.026l-.008.551z"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M117.198 124.174l-23.374-.943a1.869 1.869 0 00-1.942 1.792l-1.302 32.273a1.868 1.868 0 001.791 1.942l23.374.943a1.869 1.869 0 001.942-1.792l1.302-32.273a1.868 1.868 0 00-1.791-1.942z"
      fill="#2D2D2D"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M129.107 137.228s-11.966-3.722-14.008-4.348c-2.041-.627-13.798 8.154-14.266 9.406-.468 1.253 1.252 1.257 1.252 1.257s-.72 1.253.36 1.879a6.56 6.56 0 001.08.587s-.626 1.411.627 1.883c1.253.471 2.981-.785 2.981-.785l2.822-2.038s-3.391 4.151-2.668 5.019c.998 1.188 1.635-.087 1.635-.087l3.899-4.619 3.916-1.882s3.136 1.882 8.154 2.037c5.019.155 6.12-2.037 6.12-2.037"
      fill="#fff"
    />
    <path
      d="M129.107 137.228s-11.966-3.722-14.008-4.348c-2.041-.627-13.798 8.154-14.266 9.406-.468 1.253 1.252 1.257 1.252 1.257s-.72 1.253.36 1.879a6.56 6.56 0 001.08.587s-.626 1.411.627 1.883c1.253.471 2.981-.785 2.981-.785l2.822-2.038s-3.391 4.151-2.668 5.019c.998 1.188 1.635-.087 1.635-.087l3.899-4.619 3.916-1.882s3.136 1.882 8.154 2.037c5.019.155 6.12-2.037 6.12-2.037"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.551 146.008s4.395-3.016 5.49-4.107c1.094-1.091 4.64-3.37 5.735-3.37M109.98 145.079s2.16-2.44 2.974-2.804c.814-.364 2.002-.911 2.002-.911M102.086 143.542s6.12-4.32 8.215-5.591a29.748 29.748 0 013.913-2.005"
      stroke="#2D2D2D"
      strokeWidth={0.36}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Volume = () => {
  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.984.603c.165.064.281.2.31.36l.008.08v10.522a.48.48 0 01-.32.442.562.562 0 01-.498-.048l-.069-.052-3.053-2.75H1.565C.75 9.157.083 8.587.007 7.86L0 7.722v-2.86c0-.745.62-1.358 1.414-1.427l.15-.007h1.8L6.417.701a.557.557 0 01.567-.098zm3.174.976l.09.056.103.08a6.363 6.363 0 011.042 1.132 5.901 5.901 0 011.129 3.461 5.883 5.883 0 01-1.13 3.458 6.329 6.329 0 01-.779.895l-.147.135-.195.161-.034.026a.555.555 0 01-.734-.077.448.448 0 01.016-.612l.135-.112c.048-.04.12-.102.21-.186.176-.168.416-.422.656-.756.48-.67.959-1.654.959-2.932a5 5 0 00-.959-2.935c-.2-.28-.4-.503-.564-.668l-.176-.168-.193-.162a.453.453 0 01-.083-.673.554.554 0 01.654-.123zM9.116 3.49l.104.067.14.12.056.055c.118.117.27.288.422.516.304.46.598 1.141.598 2.054 0 .913-.294 1.596-.598 2.055-.15.229-.304.4-.422.518l-.106.1-.073.062-.042.032-.066.028c-.138.05-.46.133-.667-.103a.448.448 0 01.012-.61l.14-.123.036-.035c.078-.077.186-.198.296-.365.219-.33.447-.844.447-1.559s-.228-1.227-.446-1.557a2.377 2.377 0 00-.233-.297l-.1-.1-.07-.063a.451.451 0 01-.082-.67.554.554 0 01.654-.125z"
        fill="#B4BABE"
      />
    </svg>
  );
};

export type IconType = keyof typeof Icons;

const Icons = {
  copy,
  zoom,
  spin,
  left_arrow,
  close,
  language,
  audio,
  correct,
  wrong,
  logo,
  partners,
  home,
  activity,
  teacher,
  profile,
  eye,
  replay,
  message,
  downArrow,
  egg,
  star,
  camera,
  caret_left,
  caret_right,
  caret_right_bold,
  plus_in_circle,
  wallet,
  settings,
  contact,
  logout,
  lens,
  school,
  phone,
  envelope,
  whatsapp,
  x_logo,
  instagram,
  linkedin,
  facebook,
  play,
  chalkboard,
  check,
  checkGray,
  share,
  checkBlue,
  subscription,
  primaryCheck,
  Zoom,
  meet,
  teams,
  edit,
  checks,
  Volume,
};
export default Icons;
